import { LOCALES } from '../../utils/i18n/constants'
export default {
  [LOCALES.ENGLISH]: {
    't_aas': 'All areas',
    't_parent_fund': '(Parent fund)',
    't_account_locked': 'Account locked',
    't_action': 'Action',
    't_action_error_message': 'Please correct the issues highlighted in red',
    't_action_excel': 'SIERA Action Plan.xlsx',
    't_action_pdf': 'SIERA Action Plan.pdf',
    't_action_plan': 'Action Plan',
    't_action_completion_dates': 'Action completion dates are approaching',
    't_actions': 'Actions',
    't_actions_under_review': 'Actions under review',
    't_actual': 'Actual',
    't_not_covered': 'Not Covered',
    't_grey': 'Not Covered',
    't_add_action': 'Add action',
    't_add_an_action': 'Add an action',
    't_no_action_data': 'There are no actions to display',
    't_add_action_title': 'Add action title',
    't_add_date': 'Add Date',
    't_add_note': 'Add a note',
    't_add_note_description': 'Add a note to explain this variance in energy consumption from agreed targets.',
    't_agreed': 'Agreed',
    't_agreed_actions': 'Agreed Actions',
    't_asset_agree_actions': 'Agreed actions',
    't_all': 'All',
    't_alu': 'All utilities',
    't_all_actions': 'All actions',
    't_api_email_error': 'User email not found',
    't_applicable': 'Applicable',
    't_applicable_actions': 'Applicable actions',
    't_approved': 'Approved',
    't_apr': 'Apr',
    't_april': 'April',
    't_assets_missing_performance_targets': 'Assets missing their performance targets',
    't_asset_summary': 'Asset summary',
    't_assets': 'Asset',
    't_aug': 'Aug',
    't_august': 'August',
    't_auto_meter_readings': 'Automatic meter readings (AMR)',
    't_auto_system_upgrades': 'Automation system upgrades/replacements',
    't_back_sign_in': 'Back to Sign in',
    't_biodiversity': 'Biodiversity',
    't_biodiversity_extended': 'Indicate the total surface areas of the building, and the portion of these surface areas which is non-vegetated.',
    't_break': 'break',
    't_email_hint': 'Recipients (separate multiple email addresses with commas)',
    't_blue': 'All data collected',
    't_btn_enter': 'Enter data',
    't_btn_request': 'Request data',
    't_building_manager': 'Building Manager',
    't_building_performance': 'Building Performance',
    't_cancel': 'Cancel',
    't_capital_non_recover': 'Capital - Non recoverable',
    't_capital_recover': 'Capital - Recoverable',
    't_carbon': 'Carbon',
    't_cbx_label_all': 'Select all',
    't_certifications': 'Certifications',
    't_certificates': 'Certificates',
    't_change': 'Change',
    't_change_password': 'Change Password',
    't_check_all_completed': 'Check all as completed',
    't_close_without_save': 'Close without saving?',
    't_commercial_event': 'Commercial Event',
    't_commercial_events': 'Commercial Events',
    't_commonareas': 'Common Areas',
    't_community_engagement': 'Community Engagement',
    't_complete_by': 'Complete by',
    't_complete': 'Complete',
    't_completed': 'Completed',
    't_completed_action': 'Completed Action',
    't_completed_actions': 'Completed Actions',
    't_completion': 'Completion',
    't_completion_date': 'Date completed',
    't_composting_landscape': 'Composting landscape and/or food waste',
    't_confirm_new_password': 'Confirm new password',
    't_contact_evora': 'Contact EVORA',
    't_contact_problem_msg_1': 'Problem getting access?',
    't_contact_problem_msg_2': 'Having problems?',
    't_contact_us': 'Contact us',
    't_content': 'Content',
    't_cookies': 'Cookies',
    't_cookies_page': '<h1>Use of Cookies</h1><p>This site uses cookies – small text files that are placed on your machine to help the site provide a better user experience.</p><p>In general, cookies are used to retain user preferences, store information for things like shopping baskets, and provide anonymised tracking data to third party applications like Google Analytics. As a rule, cookies will make your browsing experience better. However, you may prefer to disable cookies on this site and on others. The most effective way to do this is to disable cookies in your browser. We suggest consulting the \'Help\' section of your browser or taking a look at the <aboutcookies>About Cookies</aboutcookies> website, which offers guidance for all modern browsers.</p><p>We use cookies to ensure that we give you the best experience on our website. There are 3 types of cookie that we use on this website:</p><h3>1. Strictly Necessary Cookies</h3><p>These cookies are used to enable core site functionality and make the site easier for you to use. They do not contain any personal information and are automatically deleted when you close your browser.</p><h3>2. Google Analytics Cookies</h3><p>These cookies provide us with statistics on how our website is used, so that we can measure and improve the performance of the site, using a service provided by Google.</p><p>Most browsers allow you to turn off the cookie function. If you want to know how to do this please look at the help menu on your browser.</p><h3>Access rights</h3><p>You have a right to access the personal data that is held about you. To obtain a copy of the personal information EVORA holds about you, or to have it deleted from our records altogether (unless it\'s information that we have the right to retain), please email <emailevora>info@evoraglobal.com</emailevora> or call us on +44 (0)20 3326 7333.</p>',
    't_cooling_tower': 'Cooling tower',
    't_cost': 'Cost',
    't_cost_type': 'Cost type',
    't_create_password': 'Create new password',
    't_current': 'Current',
    't_current_password': 'Current password',
    't_consumption': 'Consumption',
    't_add_action_plan_in_bulk': 'Add action plans in bulk',
    't_edit_action_plan_in_bulk': 'Edit action plans in bulk',
    't_data': 'Data',
    't_no_records_found': 'No records found',
    't_dashboard': 'Dashboard',
    't_dashboard_pdf': 'SIERA Dashboard.pdf',
    't_data_quality': 'Data Quality',
    't_data_quality_two_lines': 'Data {br} Quality',
    't_date': 'Date',
    't_dec': 'Dec',
    't_december': 'December',
    't_delete': 'Delete',
    't_delete_action_title': 'Delete Action',
    't_delete_confirmation': 'Are you sure?',
    't_detail': 'Detail',
    't_district_cooling': 'District Cooling',
    't_districtcooling': 'District Cooling',
    't_district_heating': 'District Heating',
    't_districtheating': 'District Heating',
    't_dq_data_entered': 'Data entered',
    't_dq_data_provided_on': 'Provided on',
    't_dq_data_requested': 'Data requested',
    't_dq_data_requested_on': 'Requested on',
    't_done': 'Done',
    't_drip_irrigation': 'Drip/smart irrigation',
    't_drought_tolerant_landscaping': 'Drought tolerant / Native landscaping',
    't_due_date': 'Due date',
    't_edit': 'Edit',
    't_electricity': 'Electricity',
    't_email': 'Your email',
    't_email_reset': 'Please check your email for details on how to login.',
    't_email_notifications': 'Email Notifications',
    't_energy': 'Energy',
    't_energyintensity': 'Energy Intensity',
    't_energy_rating': 'Energy Rating',
    't_EPC_rating': 'EPC rating',
    't_Asset_EPC_rating': 'EPC ratings',
    't_english': 'English',
    't_enter_data': 'Enter data',
    't_enter_current_password': 'Please enter your current password',
    't_error': 'Sorry, you cannot log in',
    't_error_account_locked': 'Account is locked due to too many failed attempts.',
    't_error_account_revoked': 'An administrator has revoked your access to this account.',
    't_error_ok': 'OK',
    't_error_back_to_homepage': 'Go back to the homepage',
    't_error_request_400': 'An error occurred processing your request.',
    't_error_request_401': 'You don\'t have sufficient authorisation to access that resource',
    't_page_not_found': 'Page not found',
    't_page_not_found_reason': 'You\'ve asked for a page which doesn\'t exist in this application, or you don\'t have access to it. {contactEvora} for help.',
    't_page_auth_error': 'There was a problem logging in.',
    't_page_auth_error_reason': 'There was a problem authenticating your credentials. Please check them carefully and try again.',
    't_back_to_login': 'Try logging in again',
    't_error_try_msg': 'Try again in a few hours.',
    't_error_user_password': 'Incorrect email/password please try again.',
    't_error_user_username': 'Email id is empty or invalid.',
    't_error_user_no_access': 'Incorrect email/password please try again.',
    't_error_user_account_locked': 'The account is locked for the next {lockedDuration} seconds.',
    't_error_user_internal_login_issue': 'SIERA is experiencing service issues. Please try again later.',
    't_esg_action_plan': 'Action Plan',
    't_esg_dashboard': 'Dashboard',
    't_esg_data_quality': 'Data Quality',
    't_esg_passport': 'Passport',
    't_esg_performance': 'Performance',
    't_portfolio_pdf': 'SIERA Portfolio.pdf',
    't_date_range': 'Date range',
    't_add_cost_estimate': 'Add cost estimate',
    't_add_manager': 'Add manager',
    't_est': 'EST',
    't_estimated_overspend': 'Estimated overspend',
    't_event': 'Event',
    't_events': 'Events',
    't_excel': 'Excel',
    't_expand_full_list': 'Expand full list',
    't_expiry': 't_expiry',
    't_export': 'Export',
    't_exterior': 'Exterior',
    't_feb': 'Feb',
    't_february': 'February',
    't_find_asset': 'Find asset',
    't_floor_area': 'Floor Area',
    't_forgot_password': 'Forgot password',
    't_french': 'French',
    't_friday': 'Friday',
    't_fund': 'Fund',
    't_fund_reports': 'Reports',
    't_fund_report_content': 'Reports Content',
    't_gas': 'Gas',
    't_gasFuelsAndThermals': 'Gas, Fuels & Thermals',
    't_gas_fuel_thermal': 'Gas, Fuels & Thermals',
    't_gasfuelsandthermals': 'Gas, Fuels & Thermals',
    't_german': 'German',
    't_go': 'Go',
    't_go_back': 'Go back',
    't_governance_recommendations': 'Governance Recommendations',
    't_graph_landlord': 'Landlord',
    't_tenant': 'Tenant',
    't_graph_ytd': 'Year to date',
    't_gresb_measure': 'GRESB efficiency measure',
    't_health_and_wellbeing': 'Health & Wellbeing',
    't_heatmap_header': 'Individual meters',
    't_heatmap_no_meterdata_msg': 'No meter data found for selected utility and area.',
    't_heatmap_tooltip_content_txt': '{0} data missing for {1} {2}',
    't_heatmap_tooltip_content_txt_partial': '{0} data missing for',
    't_heatmap_tooltip_content_txt_none': '{0} All data collected for {1} {2}',
    't_high_efficiency_fixtures': 'High-efficiency / Dry fixtures',
    't_impact': 'Impact',
    't_in_progress': 'In Progress',
    't_installation_equipment': 'Installation of high-efficiency equipment and appliances',
    't_instructions': 'Instructions',
    't_consumption_loader': 'Consumption loader',
    't_bulk_add_template': 'Bulk Add Template',
    't_bulk_edit_template': 'Bulk Edit Template',
    't_installation_renewable': 'Installation of on-site renewable energy',
    't_incorrect_current_password': 'Current password is incorrect.',
    't_invalid_token': 'Invalid token.',
    't_italian': 'Italian',
    't_jan': 'Jan',
    't_january': 'January',
    't_jpg': 'JPG graphs',
    't_jul': 'Jul',
    't_july': 'July',
    't_jun': 'Jun',
    't_june': 'June',
    't_kg': 'kg',
    't_kWh': 'kWh',
    't_land_fill': 'Landfill',
    't_landfill': 'Landfill',
    't_landfill_remaining': 'Landfill remaining',
    't_landlord': 'Landlord',
    't_landlord_complete': 'Landlord complete',
    't_landlord_missing': 'Landlord missing',
    't_language': 'Language',
    't_last_quarter': 'Last quarter',
    't_last_refurb': 'Last Refurb.',
    't_last_refurbished': 'Last Refurbished',
    't_latest': 'Latest',
    't_leak_detection_system': 'Leak detection system',
    't_location': 'Location',
    't_logout': 'Log out',
    't_landlord_procured': 'Landlord procured',
    't_m': 'M',
    't_management_sys_upgrade': 'Management systems upgrades/replacements',
    't_selected_asset_stranding': 'Selected asset CRREM Misalignment in ',
    't_asset_level_model_message': 'This will create a model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_manager': 'Manager',
    't_mar': 'Mar',
    't_march': 'March',
    't_may': 'May',
    't_meter_water_subsys': 'Metering of water subsystems',
    't_missing': 'Incomplete',
    't_missing_tc': 'Missing',
    't_missing_lc': 'missing',
    't_missing_performance_data': 'Missing performance data',
    't_missing_data': 'Missing data',
    't_missing_data_meter': 'Meter',
    't_missing_data_reading': 'Reading',
    't_missing_data_type': 'Type',
    't_missing_partial_data': 'Missing partial data',
    't_monday': 'Monday',
    't_msg_empty_msg': 'There is no missing data for this period',
    't_msg_no_data': 'No data',
    't_msg_qtr_empty': 'No data gaps recorded for the period selected',
    't_title_meter_view': 'Meter view',
    't_nc': 'NC',
    't_not_covered_uc': 'NOT COVERED',
    't_new_password': 'New password',
    't_no': 'No',
    't_no_action_plan': 'Sorry no data found.',
    't_no_completed_action': 'Sorry no data found for Completed Actions.',
    't_no_data_msg_1': 'Sorry we couldn\'t find any results with {0} - Try a different search term.',
    't_no_data_msg_2': 'Sorry we couldn\'t find any results.',
    't_no_events_found': 'Sorry we couldn\'t find any Events.',
    't_non_recycled': 'Non-recycled',
    't_none': 'None',
    't_non_rec': 'NON-REC',
    't_non_applicable': 'Not applicable',
    't_not_available': 'N/A',
    't_notes': 'Notes',
    't_notif_template_action': '{0} action is 1 month away from its due date. {1} ',
    't_notif_template_action_link_1': 'Add an update',
    't_notif_template_data_quality': '{0} data missing for meter: {1}. {2} or {3} from a colleague.',
    't_notif_template_data_quality_link_1': 'Request the data',
    't_notif_template_performance': '{0} performance for {1} is {2} % {3} target. {4} to explain the variance.',
    't_notif_template_performance_link_1': 'Add a note',
    't_notifications': 'Notifications',
    't_nov': 'Nov',
    't_november': 'November',
    't_occupancy': 'Occupancy',
    't_occupancy_extended': 'Track the proportion of lettable floor area occupied over time.',
    't_resource_consumption_extended': 'If development work occurred, indicate the total tonnes of raw materials used, the amount which was sustainably sourced, and the project period. Otherwise, leave this blank.',
    't_occupier_eng_tech': 'Occupier engagement / informational technologies',
    't_oct': 'Oct',
    't_october': 'October',
    't_oil': 'Oil',
    't_one_year': '1 Year',
    't_ongoing_waste_monitoring': 'Ongoing waste performance monitoring',
    't_onsite_waste_water_treatment': 'On-site waste water treatment',
    't_other': 'Other',
    't_other_notifications': 'We\'ll also notify you when:',
    't_outdoorexteriorareaparking': 'Outdoor Exterior Area Parking',
    't_over': 'Over',
    't_est_overspend': 'est. overspend',
    't_overspend': 'Overspend',
    't_passport': 'Passport',
    't_passport_pdf': 'SIERA Passport.pdf',
    't_password': 'Your password',
    't_password_criteria': 'Password doesn\'t meet the requirements',
    't_password_expiry_info': 'Your password has expired. Please create a new password.',
    't_password_mismatch': 'Passwords do not match, please check',
    't_password_must_be_different': 'The new password can not be the same as the expired password',
    't_password_rules': 'Must be 10 characters or more and include one uppercase letter, one lowercase character, a digit and a non-letter.',
    't_password_reset_success': 'Your password has been reset',
    't_past_12_months': 'Past 12 months',
    't_pdf': 'Full page PDF',
    't_pdf_exported': 'PDF exported',
    't_pdf_page': 'Page',
    't_pdf_pagination_copyright': '© Design and layout of this report is copyright of EVORA Global Limited. Data contained in this report is based solely on data provided by client and belongs to client. EVORA Global Limited is not responsible for quality or accuracy of this data.',
    't_perf_pdf': 'SIERA ESG Performance.pdf',
    't_performance': 'Performance',
    't_performance_commerial_event_template': '{0} tenant lease {1} ',
    't_performance_completed_action_template': '{0} - completed',
    't_performance_data_missing_event_template': '{0} data missing for {1} meter',
    't_performance_event_template': '{0} consumption for {1} is {2} % {3} target',
    't_performance_event_waste_template': '{0} performance for {1} is {2} % {3} target',
    't_performance_variance': 'Performance',
    't_data_quality_issue': 'Data Quality',
    't_pop_up_data_missing': 'Data missing',
    't_portfolio_name': 'Portfolio',
    't_posted': 'Posted',
    't_privacy': 'Privacy',
    't_privacy_page': '<h1>Privacy Policy</h1><p><b>EVORA is committed to protecting your privacy.</b></p><p>At EVORA Global we respect your privacy and commit to protecting your personal data. This “privacy notice” explains what we do with your personal data, why we want to use it, how we protect it, and what rights you have to control our use of it.</p><p>It applies not just to use of our website and data platforms, but also personal data that we process through other interactions with individuals in the course of running our organisation and delivering services, such as individuals working for our customers, partners and suppliers. Our websites and services are not intended for children and we do not knowingly collect data relating to children.</p><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora>.</p><h3>Some information about us as a data controller</h3><p>This privacy notice is for the EVORA Global Ltd (collectively referred to as “EVORA Global”, “we”, “us” or “our” in this privacy notice). We collect, use and are responsible for certain personal data about you. When we do so we are regulated under data protection laws and we are responsible as “data controller” of that personal information for the purposes of the law.</p><p>Our contact address is: 3rd Floor, Birrane House, 2-4 Southwark Street, London, SE1 1TQ. Our company number is 07450294.</p><h3>What personal data do we process and why?</h3><p>Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data).</p><p>We use personal data from different categories of individual for different purposes and these each have a different \'lawful basis\'. This section describes the lawful basis and purposes in detail and, although it\'s technical, we\'re required by law to explain this to you.</p><p><strong>If you visit our website:</strong>we use Google Analytics on our website to track visitor numbers and user activity on our site. We record your computer\'s IP address, so we can tell how each user and repeat visitor is using our site (your IP address is also a piece of your personal data). We do this on the basis that it is necessary for our legitimate interests in tracking website users so that we can improve our service and keep our websites relevant and useful. The IP address information will be held for 26 months after last user activity.</p><p><strong>If you are a member of our mailing list:</strong>we will use your email address for the purpose of sending you blog posts, our monthly newsletters, and invitations to our events and workshops. We have this data if you signed up on our website or if you provided us with your contact details by email or when meeting our staff. We process this data on the basis that it is necessary for our legitimate interests in promoting and marketing our business. If you no longer wish to hear from us just click the “unsubscribe” links at the bottom of each email.</p><p><strong>If you are a SIERA account holder:</strong> we will hold your name, username and email address on the basis that it is necessary for our legitimate interests in operating a building sustainability data platform for clients. You or your employer will have provided these details through the account creation process. We need these details for the purpose of enabling secure access to the data platform by staff and workers in the supply chain of our clients. We may use this information for internal analysis purposes to understand client platform engagement. We may also report information around your usage of the SIERA tool back to our client, where you work for such client or in such client\'s supply chain (see below). It is in our legitimate interests to provide feedback to our clients for purposes of running and growing our business, and assists us in responding to the needs of our clients. It is also of benefit to our clients to be aware of this usage information. If you no longer require your account, you can email us (see “How to contact us” below). We will hold your information until you or we delete your account.</p><p><strong>If you work for one of our clients or in our clients\' supply chain, or if you are an industry contact or working in a field relevant to our mission:</strong>we may hold your name, company, job title and contact details. We will have been provided with this data either by you or your employer or in some cases we may have sourced it from publicly available sources, such as LinkedIn, internet searches, or third parties. If you have been in contact with us by email or phone we may also have copies of email exchanges or conversation notes. We need this data in order to interact with you (or your employer) for the following purposes:</p><p>1. To run and develop our business; 2. To communicate with interested people regarding events, news and updates.</p><p>We do this on the basis that it is necessary for our legitimate interests in running and growing our business. We will hold your details for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><p><strong>If you submit an application to join us, whether as an employee or contractor:</strong>we will hold any personal information you provide to us (via our website or other methods), or that is sent to us by a thirdparty recruitment agency or website. This is likely to be your name, contact details and personal information contained in your CV. We do this on the basis that it is necessary for our legitimate interests in recruiting talented people. We will use this information for the purpose of communicating with you and evaluating your application. We will hold this information for as long as we need to interact with you for these purposes or until you ask us to delete it.</p><p><strong>If you are a supplier or work for a supplier:</strong>we may hold your name and contact details because we have a legitimate interest in doing business with your company. Our purpose for processing your personal data is to interact with you or your employer to procure and pay for goods and services. We will hold this information for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><h3>Retention of personal data</h3><p>We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements, taking into account applicable data protection laws, retention periods under applicable laws, limitation periods and our business needs.</p><h3>Sharing your personal data</h3><p><strong>Data processors</strong></p><p>We use a number of different service providers (acting as \'data processors\') who provide IT and system administration services to enable us to operate our business and the services we provide to our users and partners. Your personal data is transferred to (and stored by) these data processors, who generally fall under the following categories:</p><ul><li>Website analytics service providers</li><li>Website and data hosting service providers</li><li>Document storage service providers</li><li>Email, contacts, instant messaging and calendar service providers</li><li>Project management software providers</li><li>CRM service providers</li><li>Accounting software service providers</li></ul><p>For security reasons we do not name all our service providers in this privacy notice. The types of personal data we hold about you (and that may be transferred to our data processors) are set out above. Please contact us if you want further information on specific data processors or the types of personal data they process for us</p><p><strong>If you attend one of our events</strong></p><p>The name and company of attendees at our events may be shared with other participants and may be shared on our website.</p><p>If the event is co-organised with another organisation, then the name and company of attendees may also be shared with that partner organisation to enable access and name badges etc.</p><p><strong>Other circumstances in which we may need to share personal data with third parties</strong></p><p>We may also share your personal data with the following third parties in certain circumstances:</p><ul><li>We will share personal information with law enforcement or other authorities (such as tax authorities) if required by applicable law.</li><li>We may share personal information with third parties as part of a merger or transfer, acquisition or sale, or in the event of a bankruptcy. In such case, we will require the relevant third parties to provide comparable levels of protection as we provide with respect to the information we share.</li><li>We may share personal information with professional advisors such as lawyers, accountants or auditors in order for them to provide us with legal, accounting or auditing services.</li><li>We may share personal information with consultants working for us where this is necessary for them to provide their services to us or our clients.</li><li>We may share personal information with our partner company EVORA EDGE Limited – where this is necessary for them to provide services for the benefit of our clients.</li></ul><p>We will not sell or rent your information to third parties and we will never share your information with third parties for marketing purposes.</p><h3>International transfers of personal data, and the measures in place to safeguard it</h3><p>We do not directly transfer any of your personal data outside the UK or the European Economic Area (EEA). However, some of our data processors may do so and this section explains the impact of these international transfers and how your information is protected.</p><p>Many of our data processors operate “cloud-based systems”, which means the information is held in information data centres in different locations. In some cases, they hold copies of your personal information outside the UK or EEA.</p><p>In each case our processors and/or we employ one or more of the transfer safeguard mechanisms designated by data protection legislation, which are designed to help safeguard your privacy rights and give you remedies in the unlikely event of abuse. These include:</p><ul><li>Certain processors may only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data by the UK government or the European Commission. For further details, on EU adequacy decisions see: <europeancommission>European Commission: Adequacy of the protection of personal data in non-EU countries.</europeancommission></li><li>Where we use certain service providers, we may use standard contractual clauses approved by the European Commission or UK ICO, which give personal data the same protection it has in Europe. For further details, see: <europeancommissionstandard>European Commission: Standard Contractual Clauses.</europeancommissionstandard></li></ul><p>Please contact us (see below) if you want further information on the specific mechanisms used by our data processors when transferring your personal data out of the UK or EEA.</p><h3>Your personal data rights</h3><p>The personal data we hold about you is your data, and you have certain rights over the data under applicable data protection laws. This section summarises the rights you have where your personal data is protected under UK data protection legislation.</p><ul><li>You have the right to request a copy of all personal data we hold relating to you. You also have the right to require us to correct any mistakes in the personal data we hold relating to you.</li><li>Where we are processing your data based on your consent you can withdraw that consent and we must immediately stop processing your data.</li><li>Where we process your data based on a “legitimate interest” (underlined in the section on “purpose and lawful basis”, above) you still have the right to object to our processing of that data if you feel it impacts on your fundamental rights and freedoms.</li><li>You also have the right to object where we are processing your personal data for direct marketing purposes. The easiest way to do this is to use the unsubscribe links at the bottom of all marketing emails</li><li>In certain situations, you have the right to require us to erase personal data where there is no good reason for us continuing to process it, or to request restriction of processing of your personaldata.</li><li>Finally, you have the right to request the transfer of your personal data to you or a third party in a structured, commonly used, machine-readable format in certain circumstances.</li></ul><p>For further information on each of these rights, including the circumstances in which they apply, see the <guidanceuk>Guidance from the UK Information Commissioner\'s Office (ICO) on individuals rights under the General Data Protection Regulation.</guidanceuk></p><p>If you would like to exercise any of these rights, the easiest way is by dropping us an email (see “How to contact us” below).</p><h3>Automated processing of your personal data</h3><p>You have a right to object to any decisions being taken through the processing of your personal data by automated means if they produce legal effects concerning you or similarly significant effects on you. We can confirm that we do not undertake any automated decision-making, or profiling, based on the processing of personal data.</p><h3>Keeping your personal information secure</h3><p>We have appropriate security measures in place to prevent personal information from being accidentally lost, or used or accessed in an unauthorised way. In addition, we limit access to your personal data to those employees, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality.</p><p>We also have procedures in place to deal with any suspected data security breach. We will notify you and any applicable regulator of a suspected data security breach where we are legally required to do so.</p><h3>Your rights to lodge a complaint with the Regulator</h3><p>At all times, you have the right to report a concern or lodge a complaint with the Information Commissioner\'s Office. Please refer to the ICO at<icoorg> https: //ico.org.uk/concerns/</icoorg> or by calling them on 0303 123 1113. Of course, we hope that we can resolve your issue quickly and fairly ourselves.</p><h3>Changes to this privacy notice</h3><p>This privacy notice was last updated on 16th February 2021. We may change this privacy notice from time to time by amending this page.</p><h3>How to contact us</h3><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora></p>',
    't_provider': 'Provider',
    't_quarterly_email_notification': 'Get quarterly emails highlighting:',
    't_recycled': 'Recycled',
    't_recycling': 'Recycling',
    't_reduction': 'Reduction',
    't_req_from': 'From',
    't_req_hi': 'Hi',
    't_red': 'Data missing',
    't_req_meter': 'Meter',
    't_req_missing_data_period': 'Missing data period (s)',
    't_req_recipient': 'Recipients',
    't_req_send': 'Send',
    't_req_subject': 'Subject',
    't_req_thanks': 'Thanks',
    't_req_utility': 'Utility',
    't_request_data': 'Request data',
    't_reset': 'Reset',
    't_req_supplier': 'Supplier (if known)',
    't_reuse_storm_water': 'Reuse of storm water and/or grey water',
    't_revenue_service': 'Revenue - Service Charge',
    't_saturday': 'Saturday',
    't_save': 'Save',
    't_saving': 'est. saving',
    't_scope': 'Scope',
    't_select': 'Select',
    't_send_reminder': 'Send a reminder',
    't_sep': 'Sep',
    't_september': 'September',
    't_set_dates': 'Set dates',
    't_set_reminder_date': 'Set Reminder Date',
    't_settings': 'Settings',
    't_sharedservices': 'Shared Services',
    't_show_more': 'Show more',
    't_sign_in': 'Sign in',
    't_six_months': '6 Months',
    't_smart_grid_tech': 'Smart grid / Smart building technologies',
    't_social_value': 'Social Value',
    't_sort_by': 'Sort By',
    't_spanish': 'Spanish',
    't_status': 'Status',
    't_submit': 'Submit',
    't_sunday': 'Sunday',
    't_swedish': 'Swedish',
    't_sys_commissioning': 'Systems commissioning or retro-commissioning',
    't_title_summary': 'Summary',
    't_target': 'Target',
    't_targets': 'Targets',
    't_targets_and_pathways': 'Targets & Pathways',
    't_task': 'Task',
    't_template_qtr_label': '{0} {1} - {2} {3} ',
    't_tenant_complete': 'Tenant complete',
    't_tenant_missing': 'Tenant missing',
    't_tenant_engagement': 'Tenant Engagement',
    't_tenant_services': 'Tenant services',
    't_tenantspace': 'Tenant Space',
    't_terms': 'Terms',
    't_this_quarter': 'This quarter',
    't_three_months': '3 Months',
    't_thursday': 'Thursday',
    't_title_cannot_request_data': 'Cannot request data',
    't_title_cannot_post_data': 'Add user failed',
    't_title_cannot_put_data': 'Update user failed',
    't_title_cannot_put_data_group': 'Update group failed',
    't_title_cannot_post_data_group': 'Add group failed',
    't_title_cannot_add_asset': 'Add asset failed',
    't_today': 'Today',
    't_ton': 't',
    't_tonnes': 'tonnes',
    't_total': 'Total',
    't_total_recycling': 'Total Recycling',
    't_try_again': 'Try again',
    't_tuesday': 'Tuesday',
    't_type': 'Type',
    't_tenant_procured': 'Tenant procured',
    't_under': 'under',
    't_under_review': 'Under review',
    't_under_target': 'Under target for period',
    't_util_cooling': 'District Cooling',
    't_util_heating': 'District Heating',
    't_utility_type': 'Utility type',
    't_view_all': 'View All',
    't_wall_roof_inst': 'Wall / Roof insulation',
    't_waste': 'Waste\n' +
        'Recycling',
    't_waste_title': 'Waste {0} Recycling',
    't_waste_recycling': 'Waste Recycling',
    't_waste_management': 'Waste management',
    't_waste_stream_audit': 'Waste stream audit',
    't_water': 'Water',
    't_wednesday': 'Wednesday',
    't_wellbeing': 'Wellbeing',
    't_wholebuilding': 'Whole Building',
    't_window_replacement': 'Window replacements',
    't_yes': 'Yes',
    't_yesterday': 'Yesterday',
    't_y_o_y': 'Year on year',
    't_y_o_y_dialog_text': '<p><strong>Target variance</strong> refers to an asset\'s performance this year to date, compared with the same period last year for a given utility, displayed as a year-on-year percentage change. If a target has been set on an asset in SIERA for utility, then this percentage is based on the previous year.</p>',
    't_y_o_y_target': 'Year-to-date, variance from target',
    't_ytd': 'Year to date, variance from target',
    't_ytd_uppercase': 'YTD',
    't_yellow': 'Data estimated',
    't_show_targets': 'Show Targets',
    't_estimated': 'Estimated',
    't_estimate': 'ESTIMATED',
    't_start_date': 'Start date',
    't_end_date': 'End date',
    't_month': 'Month',
    't_year': 'Year',
    't_add_exposure_record': 'Add another exposure record',
    't_add_gav_record': 'Add another GAV record',
    't_add_occupancy_record': 'Add another occupancy record',
    't_add_record': 'Add another record',
    't_reporting_year': 'Reporting Year',
    't_report_data_checklist': 'Report data checklist',
    't_missing_field_description': 'Missing Field Descriptions',
    't_asset_values': 'Asset Values',
    't_fossil_fuel_exposure': 'Fossil Fuel Exposure',
    't_exposure': 'Exposure',
    't_exposure_select': 'Select Exposure',
    't_planning_permission': 'Planning Permission',
    't_planning_permission_extended': 'Indicate the date the asset received planning permission. This is used to determine the energy efficiency standards the building must meet.',
    't_planning_permission_date': 'Planning Permission Date',
    't_epc_coverage': 'EPC Coverage',
    't_ped': 'PED',
    't_horizontal_artificial': 'Horizontal artificial',
    't_horizontal_artificial_areas' : 'Horizontal artificial areas',
    't_vertical_artificial': 'Vertical artificial',
    't_vertical_artificial_areas' : 'Vertical artificial areas',
    't_nzeb_threshold': 'NZEB Threshold',
    't_asset_floor_area': 'Asset Floor Area',
    't_total_raw_materials_weight': 'Total Raw Materials Weight',
    't_sustainable_raw_materials_weight': 'Sustainable Raw Materials Weight',
    't_total_horizontal_area': 'Total Horizontal Area',
    't_total_vertical_area': 'Total Vertical Area',
    't_artificial_horizontal_area': 'Artificial Horizontal Area',
    't_artificial_vertical_area': 'Artificial Vertical Area',
    't_asset_values_extended': ' ',
    't_fossil_fuel_exposure_extended': 'An asset is exposed to fossil fuels if it is involved in the extraction, storage, transport or manufacture of fossil fuels. This should be updated quarterly.',
    't_fossil_fuel_exposure_extended_edit_data': 'Track whether the asset is involved in the extraction, transport, storage or manufacture of fossil fuels. This status should be confirmed quarterly.',
    't_planning_permission_date_extended': ' ',
    't_epc_coverage_extended': ' ',
    't_ped_extended': 'Indicate the Primary Energy Demand (PED) of the asset, and the Nearly Zero-Energy Building (NZEB) Threshold against which this is compared, if applicable.',
    't_nzeb_threshold_extended': 'A Nearly Zero-Energy Building is one which meets or exceeds an energy performance target calculated according to the appropriate national methodology, for EU nations. Non-EU nations will not have an applicable NZEB threshold.',
    't_asset_floor_area_extended': 'The gross internal area of the asset.',
    't_waste_management_extended': 'An asset has implemented waste management processes if it is equipped with facilities for waste sorting, and covered by a waste recovery or recycling contract.',
    't_total_raw_materials_weight_extended': 'The total weight of raw materials used in new construction or major redevelopment at the asset.',
    't_sustainable_raw_materials_weight_extended': 'Sustainable raw materials refers to materials which are recovered, recycled or bio-sourced.',
    't_total_horizontal_area_extended': 'This refers to the “plan” or “bird\'s eye” area of the plot, not the internal area.',
    't_total_vertical_area_extended': 'This refers to external, vertical surface area.',
    't_artificial_horizontal_area_extended': '“Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Horizontal Area.',
    't_artificial_vertical_area_extended': '“Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Vertical Area.',
    't_source': 'Source',
    't_reading': 'Reading',
    't_picker_filter_value': '{0} months to end of {1} {2}',
    't_picker_filter_value_single_month': '{0} month to end of {1} {2}',
    't_variance_from_target': 'Variance from target / previous year',
    't_rank': 'Rank',
    't_target_missed': 'Target missed',
    't_higher_than_previous': 'Higher than previous year',
    't_lower_than_previous': 'Lower than previous year',
    't_under_recycling_target': 'Under recycling target for period',
    't_over_recycling_target': 'Over recycling target for period',
    't_target_beaten': 'Target beaten!',
    't_variance': 'Variance',
    't_previous': 'Previous',
    't_percentage_missing': '% of data is missing',
    't_savings': 'Savings',
    't_est_savings': 'est. savings',
    't_annual_current_consumption': 'Annual current consumption',
    't_annual_expected_consumption': 'Annual expected consumption',
    't_add_note_dots': 'Add note...',
    't_agreed_action': 'Agreed Action',
    't_applicable_action': 'Applicable Action',
    't_action_under_review': 'Action Under Review',
    't_notes_lowercase': 'notes',
    't_add_variance_note': 'Add a note to explain the variance',
    't_delete_warning': 'Are you sure you want to delete this action?',
    't_details': 'Details',
    't_clear': 'Clear',
    't_groups': 'Groups',
    't_my_groups': 'My Groups',
    't_edit_user': 'Edit user',
    't_add_photo': 'Add photo',
    't_name': 'Name',
    't_company': 'Company',
    't_role': 'Role',
    't_email_address': 'Email address',
    't_required_fields': 'Required fields ',
    't_save_exit': 'Save and exit',
    't_post': 'Post',
    't_edited': 'edited',
    't_close': 'Close',
    't_calendar': 'Calendar',
    't_chart': 'Chart',
    't_exclamation': 'Exclamation',
    't_hand_right': 'Index finger pointing',
    't_info': 'Info',
    't_no_notes': 'No notes to display',
    't_no_redirect_data': 'No redirect data from server',
    't_old_password': 'Old password',
    't_confirm_password': 'Confirm password',
    't_property': 'Property',
    't_refresh': 'Refresh',
    't_show_hide_pass': 'Show/Hide password',
    't_tick': 'Tick',
    't_help': 'Help',
    't_help_assistance': 'If you ever need Help, click here for assistance.',
    't_meters': 'Meters',
    't_action_happen': 'When action will happen',
    't_action_completed': 'When action is completed',
    't_date_format_check': 'This date format is not recognised, please check',
    't_show_me': 'Show me',
    't_months': 'months',
    't_end_of': 'to end of',
    't_note_post_warning': 'Hit \'Post\' to add your note before closing',
    't_review_date': 'Review date',
    't_warning': 'Warning',
    't_warning_asset_review': 'This asset is currently being reviewed by an Evora consultant. Contact support@evoraglobal.com for more information.',
    't_string': '-',
    't_dq_landlord_pdf': 'SIERA Data Quality Landlord.pdf',
    't_dq_tenant_pdf': 'SIERA Data Quality Tenant.pdf',
    't_dq_meter_pdf': 'SIERA Data Quality Meter.pdf',
    't_performance_excel': 'SIERA Performance.xlsx',
    't_data_quality_zip': 'SIERA Data Quality.zip',
    't_data_quality_excel': 'SIERA Data Quality.xlsx',
    't_area': 'Area',
    't_events_pfg_msg': 'Peformance may have been affected by these events',
    't_last_edit': 'Last edit',
    't_reports_create': 'Create Report',
    't_completed_data_requirements':'Completed Data Requirements',
    't_reports_no_assets': 'No assets owned in the reporting year',
    't_reports_SFDR': '{count} SFDR fields',
    't_reports_missing_required': 'Missing Required Fields',
    't_reports_missing_optional': 'Missing Optional Fields',
    't_reports_report_created_on': 'Report created on',
    't_reports_data_completeness': 'Data Completeness',
    't_reports_data_completeness_missing': 'Consumption Data Missing',
    't_reports_report_completeness': 'Report Completeness',
    't_reports_report_completeness_missing': '{count} Assets are missing required data.',
    't_reports_percentage_complete': '{percentage}% complete',
    't_reports_percentage_complete_consumption_data': '{percentage}% complete consumption data',
    't_reports_create_report_header': '{year} Report',
    't_reports_save': 'Save Report',
    't_reports_assetplanningpermissiondate_not_found': 'Planning Permission Date',
    't_reports_assetnzeb_not_found': 'NZEB Threshold',
    't_reports_assetped_not_found': 'Primary Energy Demand',
    't_reports_giaM2_not_found': 'GIA (M2)',
    't_reports_gresbmgtstatus_not_found': 'GRESB Management Status',
    't_reports_artificialhorizontalarea_not_found': 'Artificial Horizontal Area',
    't_reports_artificialverticalarea_not_found': 'Artificial Vertical Area',
    't_reports_totalhorizontalarea_not_found': 'Total Horizontal Area',
    't_reports_totalverticalarea_not_found': 'Total Vertical Area',
    't_reports_gav_not_found': 'GAV',
    't_reports_fossilfuelexposure_not_found': 'Fossil Fuel Exposure',
    't_reports_wasteproduction_not_found': 'Waste Data',
    't_reports_constructionmaterialweight_not_found': 'Resource Consumption Data',
    't_reports_assetepc_not_found': 'EPC not found',
    't_reports_assetepc_not_valid': 'EPC not valid',
    't_reports_assetepc_insufficient_coverage': 'EPC insufficient coverage',
    't_reports_assetepc_not_found_msg': 'No EPCs were found for this asset, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset, or indicate that it is exempt from these requirements below.',
    't_reports_assetepc_not_valid_msg': 'The EPCs at this asset are not valid for the reporting period, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset.',
    't_reports_assetepc_insufficient_coverage_msg': 'The EPCs at this asset do not cover sufficient floor area, so it will be categorised as energy-inefficient. If this is incorrect, provide additional EPC(s), or indicate that units are EPC exempt.',
    't_explanation': 'Explanation',
    't_explanation_placeholder': 'Type in explanation',
    't_actions_taken': 'Actions Taken',
    't_actions_taken_placeholder': 'Type in actions taken',
    't_adverse_impact': 'Adverse Impact',
    't_fossil_fuels_exposure': 'Fossil Fuels Exposure',
    't_energy_efficiency': 'Energy Efficiency',
    't_energy_consumption': 'Energy Consumption',
    't_resource_consumption': 'Resource Consumption',
    't_adverse_impact_fossil_fuels': 'Exposure to fossil fuels through real estate assets.',
    't_adverse_impact_energy_efficiency': 'Exposure to energy-inefficient real estate assets.',
    't_adverse_impact_ghg_emissions': 'Greenhouse Gas Emissions',
    't_adverse_impact_energy_consumption': 'Energy Consumption Intensity',
    't_adverse_impact_waste': 'Waste production in operations',
    't_adverse_impact_resource_consumption': 'Raw materials consumption for new construction and major renovations',
    't_adverse_impact_biodiversity': 'Land artificialisation',
    't_impact_value': 'Impact Value',
    't_impact_value_fossil_fuels': 'Share of investments in real estate assets involved in the extraction, storage, transport or manufacture of fossil fuels.',
    't_impact_value_energy_efficiency': 'Share of investments in energy-inefficient real-estate assets',
    't_impact_value_ghg_emissions': 'Scope 1, 2, 3 and Total emissions generated by real estate assets',
    't_impact_value_energy_consumption': 'Energy consumption in GWh of owned real estate assets per square meter of gross internal area',
    't_impact_value_waste': 'Share of real estate assets not equipped with facilities for waste sorting and not covered by a waste recovery or recycling contract',
    't_impact_value_resource_consumption': 'Share of raw building materials (excluding recovered, recycled and biosourced) compared to the total weight of building materials used in new construction and major renovations',
    't_impact_value_biodiversity': 'Share of non-vegetated surface area (surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls) compared to the total surface area of the plots of all assets',
    't_lease': 'Lease',
    't_back_t_a_users':'Back to all users',
    't_members':'Members',
    't_groups_none': 'No Groups Found',
    't_assets_none': 'No Assets Found',
    't_selected':'selected',
    't_access':' to access',
    't_upload': 'Upload',
    't_add_asset': 'Add asset',
    't_upload_select_or_drop_file': 'Select or drop a file',
    't_upload_here_jpg': 'here (JPG)',
    't_upload_image': 'Upload image',
    't_upload_footer_info': 'Image file must be a jpg/png and no bigger than 2mb in size',
    't_choose_assets_for':'Choose resources for',
    't_admin': 'Admin',
    't_administrator': 'Administrator',
    't_user1': 'User1',
    't_user': 'User',
    't_users': 'Users',
    't_add_user': 'Add user',
    't_asset_s': 'Assets',
    't_recycling_target_beaten': 'Recycling target beaten',
    't_more_recycled_than_previous_year': 'More recycled than previous year!',
    't_recycling_target_missed': 'Recycling target missed',
    't_less_recycled_than_previous_year': 'Less recycled than previous year',
    't_next_choose_groups': 'Next - Choose Groups',
    't_next_choose_assets': 'Next - Choose Assets',
    't_choose_groups_for_new_user': 'Choose the users that will have access to this group',
    't_choose_groups_for_update_user': 'Choose the groups {0} has access to',
    't_choose_users_for_update_group': 'Choose the users {0} has access to',
    't_choose_users_who_will_be_able_to_access_group': 'Choose users who will be able to access ‘{0}’',
    't_find_group': 'Find group',
    't_add_new_group': 'Add new group',
    't_created': 'Created',
    't_choose_assets_for_update_user': 'Choose the assets {0} has access to',
    't_choose_assets_for_new_user': 'Choose the assets this user will have access to',
    't_last_login': 'Last login',
    't_add_new_user': 'Add new user',
    't_find_user': 'Find user',
    't_home': 'Home',
    't_users_not_found': 'Sorry we couldn\'t find any Users.',
    't_title_cannot_post_user_asset_groups': 'Add user asset groups failed',
    't_title_cannot_put_user_asset_groups': 'Update user asset groups failed',
    't_contact_problem_access': 'Problem getting access',
    't_full_name': 'Full name',
    't_create_siera_account': 'Create your SIERA account',
    't_password_not_match': 'Passwords do not match',
    't_title_cannot_signup': 'Signup failed',
    't_title_cannot_post_user_asset_access': 'Add user asset access failed',
    't_title_cannot_put_user_asset_access': 'Update user asset access failed',
    't_retail': 'Retail',
    't_office': 'Office',
    't_industrial': 'Industrial',
    't_residential': 'Residential',
    't_hotel': 'Hotel',
    't_lodgingleisurerecreation': 'Lodging Leisure Recreation',
    't_education': 'Education',
    't_technologyscience': 'Technology Science',
    't_healthcare': 'Healthcare',
    't_mixeduseoffice': 'Mixed Use Office',
    't_asset_details': 'Asset details',
    't_periodic_reporting_data': 'Periodic reporting data',
    't_select_sector': 'Select sector',
    't_energy_star_sector': 'Energy Star sector',
    't_select_energy_star_sector': 'Select Energy Star sector',
    't_select_gresb_sector': 'Select GRESB sector',
    't_gav_evaluation_date': 'GAV evaluation date',
    't_building_utilities': 'Building utilities present',
    't_select_building_utilities': 'Select building utilities present',
    't_operation_control': 'Operational control',
    't_select_operational_control': 'Select operational control',
    't_building_details': 'Building details',
    't_postcode': 'Postcode',
    't_city': 'City',
    't_select_city': 'Select a city',
    't_select_country': 'Select a country',
    't_select_region': 'Select a region',
    't_select_date': 'Select date',
    't_select_fund': 'Select a fund',
    't_asset_ownership': 'Fund ownership',
    't_sold_date': 'Sold date',
    't_year_built': 'Year built',
    't_select_asset_status': 'Select asset\'s current status',
    't_current_status': 'Current status',
    't_lifecycles_explanation': 'Ensure accurate reporting and data calculations by tracking asset events.',
    't_lifecycles': 'Lifecycle',
    't_current_status_tooltip': 'What is your asset\'s current stage in its ownership lifecycle?',
    't_asset_ref_tooltip': 'A unique name you assign to assets for easy identification within Siera.',
    't_land': 'Land',
    't_standing_investment': 'Standing Investment',
    't_new_construction': 'New Construction',
    't_major_renovation': 'Major Renovation',
    't_static_reporting_data': 'Static reporting data',
    't_key_dates': 'Key dates',
    't_epc': 'EPC',
    't_users_groups': 'Users & Groups',
    't_asset_name_tc': 'Asset Name',
    't_asset_reference_tc': 'Asset Reference',
    't_asset_name': 'Asset name',
    't_asset_reference': 'Asset reference',
    't_find_address': 'Find address',
    't_add_address_manually': 'Add address manually',
    't_number_identifier': 'Number / Identifier',
    't_street': 'Street',
    't_town_city': 'Town/City',
    't_county': 'County',
    't_country': 'Country',
    't_region': 'Region',
    't_postcode_zip': 'Postcode/ZIP',
    't_sector_type': 'Sector type',
    't_gross_asset_value': 'Gross Asset Value (GAV)',
    't_fri': 'Full repairing and insuring lease',
    't_floor_areas': 'Floor Areas',
    't_gia': 'Gross Internal Area (GIA)',
    't_nla': 'Net Lettable Area (NLA)',
    't_cpa': 'Common Parts Area (CPA)',
    't_ext': 'External Area (EXT)',
    't_units': 'Units',
    't_units_desc': 'Do you want to be able to add data for units? (You can do this later)',
    't_next_add_key_dates': 'Next - Add Key dates',
    't_form_error_message': 'Please fill all the required fields',
    't_asset_existing_group': 'This asset is part of a selected fund or group',
    't_organisation': 'Organisation',
    't_user_warning_message': 'Are you sure you want to cancel this action?',
    't_user_invited_to_join_siera': '{0} has been invited to join SIERA',
    't_user_creation_confirmation_popup_title': 'Confirmation',
    't_user_revocation_successful': '{0} has been successfully revoked',
    't_resend_invite': 'Resend invite',
    't_instance': 'Instance',
    't_instance_different': 'Please select an instance which is not your current one.',
    't_change_instance': 'Change instance',
    't_change_instance_explanation': 'When you change of instance you will be automatically logged out and redirected to the correct instance login screen where you can use your usual credentials.',
    't_wrong_instance': 'Switch instance?',
    't_wrong_instance_explanation': 'You are trying to access an instance which is not your active one. Do you want to switch instances?',
    't_continue_to': 'Re-login to',
    't_switch_to': 'Yes, switch to',
    't_could_not_find_groups': 'Sorry we couldn\'t find any Groups.',
    't_developer': 'Developer',
    't_delete_group': 'Delete Group',
    't_description': 'Description',
    't_groups_not_found': 'Sorry we couldn\'t find any Groups.',
    't_view_all_resources': 'View all {0} resources',
    't_view_all_assets': 'View all {0} assets',
    't_fund_name': 'Fund name',
    't_investment_stage': 'Investment stage',
    't_search_scheme_asset_name': 'Search by scheme and asset name',
    't_green_building_certificates': 'Green Building Certificates',
    't_energy_rating_certification': 'Energy Rating Certification', 
    't_scheme': 'Scheme',
    't_reference_no': 'Reference no',
    't_rating': 'Rating',
    't_score': 'Score',
    't_unit': 'Unit',
    't_certified_floor_area': 'Certified floor area',
    't_valid_from_date': 'Valid from date',
    't_file_upload': 'File upload',
    't_uploaded_date': 'Upload date',
    't_gav': 'GAV',
    't_sustainable_tonnes': 'Sustainable tonnes',
    't_total_tonnes': 'Total tonnes',
    't_gav_extended': 'Track the gross value of the asset.',
    't_total_floor_area': 'Total floor area',
    't_contains': 'Contains',
    't_total_floor_area_gia': 'Total floor area (GIA)',
    't_financial_year_starts': 'Financial year starts',
    't_carbon_emissions': 'Carbon Emissions',
    't_energy_intensity': 'Energy intensity',
    't_recycledwaste': 'Recycled Waste',
    't_gap_filled_data': 'gap-filled data',    
    't_below_target': 'below target',
    't_above_target': 'above target',
    't_key_facts': 'Key facts',
    't_funds': 'Funds',
    't_my_organisations': 'My Organisations',
    't_net_zero_carbon': 'Net Zero Carbon',
    't_cco_fund_model': 'CCO Fund - Model',
    't_data-source_nzc': 'Data source: SIERA',
    't_kg_co2_year': 'kgCO₂e/m²/year',
    't_kwh_m2_year': 'kWh/m²/year',
    't_bau_ghg_intensity': 'Business as usual (BAU)',
    't_scientific_ghg_intensity': 'Science based target (1.5C)',
    't_scientific_ghg_intensity(2.0)': 'Science based target (2.0C)',
    't_no_organisations_message': 'No Organisations Found',
    't_rise': 'rise',
    't_fall': 'fall',
    't_next_choose_funds': 'Next - Choose Funds',
    't_find_fund': 'Find fund',
    't_choose_funds_for_user': 'Choose the funds this user will have access to',
    't_choose_funds_for_update_user': 'Choose the funds {0} has access to',
    't_proportion_missing_data': 'Portion of missing fund data',
    't_incomplete': 'Incomplete',
    't_incomplete_data': 'Incomplete data',
    't_total_missing': 'Total missing',
    't_user_revoke_confirm_message': 'This user will be deactivated and will no longer be able to log in.',
    't_revoke_access': 'Revoke access',
    't_grant_access': 'Grant access',
    't_user_access_revoked': 'This user\'s access has been revoked',
    't_actions_by_assets': 'Actions by asset ({0})',
    't_overdue': 'Overdue',
    't_items_per_page': 'Items per page',
    't_of': 'of',
    't_total_costs': 'Total costs',
    't_non_recoverable': 'Non-recoverable',
    't_un_costed': 'Un-costed',
    't_gap_filled_data_above_target': 'Gap-filled data (above target)',
    't_actual_data_above_target': 'Actual data (above target)',
    't_actual_data_legend': 'Actual data',
    't_estimated_data_legend': 'Estimated data',
    't_incomplete_data_legend': 'Incomplete data',
    't_not_covered_data_legend': 'Not covered',
    't_gap_filled_data_legend': 'Gap-filled data',
    't_over_target_legend': 'Over target',
    't_show': 'Show',
    't_quarterly_data': 'Quarterly data',
    't_monthly_data': 'Monthly data',
    't_how_we_calculate': 'How we calculate this',
    't_fund_graph_carbon_explanation': 'Graph showing total carbon emissions for scopes 1, 2 and 3.',
    't_site_admin': 'Site admin',
    't_my_account': 'My account',
    't_my_profile': 'My profile',
    't_aggregated_performance_assets_model': 'Aggregated performance for assets used in model',
    't_agreed_overlay_text': 'In the current NZC model, assetCountWithNoAgreedActions out of totalAssets assets have no agreed energy-saving actions.',
    't_action_based_overlay_text': 'In the current NZC model, all totalAssets assets have at least one energy-saving action defined.',
    't_asset_error_message': 'Selected assets does not have sufficient data',
    't_aggregated_data_quality_assets_model': 'Aggregated data quality for assets used in model',
    't_based_on_baseline_year': 'Based on baseline year',
    't_based_on_year': 'Based on year',
    't_carbon_intensity': 'Carbon intensity',
    't_cost_intensity': 'Cost intensity',
    't_co2_emissions': 'CO₂e emissions',
    't_feedback-panel-label': 'How could we improve this page?',
    't_feedback_form_header': 'Your feedback',
    't_feedback_form_info': 'Would you be happy to speak to us in more depth about your experience of using SIERA?',
    't_feedback_form_label': 'Yes, I am happy to be contacted to give more feedback',
    't_target_delta': 'target/delta',
    't_sector': 'Sector',
    't_no_data_available': 'There is no data available',
    't_feedback_success': 'Successfully Sent the feedback',
    't_add_feedback_failed': 'Add user feedback failed',
    't_about_scopes': 'About scopes',
    't_about_scopes_info': 'These carbon emission metrics illustrate the impact of activities required to directly run a buildling— i.e. heating, lighting, etc. They includes tenant (scope 3) emissions for utilities used by building tenants but do not include extended activites required for the tenant\'s business.',
    't_more_details': 'More details',
    't_user_last_loggedIn_at': 'Last logged in at {0} on {1}',
    't_total_data_missing': 'Total data missing',
    't_landlord_data_missing': 'Landlord data missing',
    't_tenant_data_missing': 'Tenant data missing',
    't_total_waste': 'Total waste',
    't_water_intensity': 'Water intensity',
    't_assets_wo_agreed_action': 'Assets without agreed actions',
    't_assets_wo_completed_action': 'Assets without completed actions',
    't_coverage_by_floor_area': 'Floor area coverage',
    't_valid_certs_by_floor_area': 'Valid certificates by floor area',
    't_expire_within_12_months': 'Expire within 12 months',
    't_no_certs': 'No certificates found',
    't_top_impact_cat': 'Top 5 impact categories',
    't_user_not_logged_in': 'User has not logged in yet.',
    't_total_data': 'Total data',
    't_landlord_proc_data': 'Landlord-procured data',
    't_tenant_proc_data': 'Tenant-procured data',
    't_landlord_proc_building': 'Landlord procures whole building',
    't_tenant_proc_building': 'Tenant procures whole building',
    't_otherfuelsandthermals': 'Other Fuels & Thermals',
    't_funds_none': 'No Funds Found',
    't_funds_performance_cost_higher': 'higher than previous period',
    't_funds_performance_cost_lower': 'lower than previous period',
    't_gap_filled_data_NA': 'gap-filling not available',
    't_only_for_annual_data': 'Only available for annual data.',
    't_performance_energy_intensity_coming_soon': 'Performance for Energy Intensity coming soon.',
    't_non_recycled_waste': 'Non-recycled waste',
    't_total_carb_emissions': 'total carbon emissions',
    't_total_elec_used': 'total electricity used',
    't_total_gas_fuels_thermals': 'total gas fuels & thermals',
    't_total_water_used': 'total water used',
    't_total_recycled_waste': 'total recycled waste',
    't_fund_rise_than_previous_period': 'rise over previous period!',
    't_fund_fall_than_previous_period': 'fall over previous period!',
    't_estimated_saving': 'estimated saving',
    't_nzc_available_siera': 'Net Zero Carbon available in SIERA',
    't_epc_analysis': 'EPC Analysis',
    't_water_units': 'm³',
    't_assets_in_the_model':'assets in the model',
    't_date_of_export': 'Date of export',
    't_target_pathway_info': 'Target pathways allow you to define a year-on-year plan for % carbon reduction for your model,\n relative to your baseline year.',
    't_action_based_target_pathway': 'Action-based pathways aggregate all of the energy-saving actions that have been defined for the assets in the current model and present them as a single pathway for your fund.',
    't_science_based_target_pathway': 'This is an area weighted decarbonisation pathway based on your selected assets aligned to the Paris Climate Goals. This shows the carbon intensity required to keep in line with the commitments to limit global warming.',
    't_custom_target_pathway': 'Custom target pathways allow you to specify your own targets over time for assets in your model.',
    't_target_pathway_1': 'Target Pathway 1',
    't_action_based_carbon_pathway': 'Action based pathway',
    't_action_based_energy_intensity_pathway': 'Action based energy intensity pathway',
    't_action_based_pathways': 'Action-based pathways',
    't_energy_saving_action': 'Use energy-saving actions to generate a NZC pathway',
    't_agreed_actions_count': '{0} Agreed actions (required)',
    't_applicable_actions_count': '{0} Applicable actions (recommended)',
    't_science_based_target': 'CRREM Science Based Targets (SBT)',
    't_SBT_option_1': '1.5C SBT',
    't_SBT_option_2': '2.0C SBT',
    't_custom_target_pathways': 'Custom target pathways',
    't_tp_stranding_year': 'CRREM Misalignment year in ',
    't_target_stranding_year': 'Target pathway CRREM Misaligned in ',
    't_bau_stranding_year': 'BAU CRREM Misalignment in ',
    't_show_progress_towards_target_for': 'Show progress towards target for ',
    't_cumulative': 'Cumulative',
    't_apply': 'Apply',
    't_grid_decarbonisation': 'grid decarbonisation',
    't_title_cannot_create_target_pathway': 'Create target pathway failed',
    't_improvement': 'Improvement',
    't_epc_available_siera': 'Detailed EPC analysis available in SIERA',
    't_waste_utility': 'Waste',
    't_waste_contracts': 'Waste Contracts',
    't_waste_contracts_extended': 'Track whether the asset is equipped with facilities for waste sorting and covered by a waste recovery or recycling contract.',
    't_contract_status': 'Contract Status',
    't_model': 'Model',
    't_models': 'Models',
    't_create_new_model': 'Create a new model' ,
    't_open_model': 'Open a model' ,
    't_share_model': 'Share model',
    't_link': 'Link',
    't_copy_link': 'Copy link',
    't_link_copied': 'Link copied',
    't_share': 'Share',
    't_duplicate_model': 'Duplicate model',
    't_export_config_data': 'Export configuration data',
    't_import_config_data': 'Import configuration data',
    't_search': 'Search',
    't_open': 'Open',
    't_no_models_are_created_yet': 'No models are created yet',
    't_default_model': 'Set as Default model',
    't_delete_model': 'Delete model',
    't_delete_yes_cancel': 'delete this! /',
    't_bau_stranding': 'BAU CRREM Misalignment',
    't_no_model': 'No models found',
    't_create_new_model_para': 'This will create a model from all current, valid assets in this fund.  Any assets which do not have enough consumption data will have a sector and country benchmark applied.',
    't_create': 'Create',
    't_name_required': 'Name is required.',
    't_model_name_not_valid': 'Enter a valid model name',
    't_save_changes': 'Save changes',
    't_filter': 'Filter',
    't_all_sectors': 'All sectors',
    't_all_countries': 'All countries',
    't_assets_filter_result': '{0} out of {1} assets will be displayed',
    't_assets_filter_count': 'filters selected:',
    't_assets_filter_title': 'Filter',
    't_about_gap_filled_data': 'About gap-filled data',
    't_gap_filled_data_dialog_content': '<p>Gap-filling missing data is less accurate than using complete\nactual data, but does allow users to\nsee an indicative, realistic picture\nof a fund or asset\'s performance.</p>',
    't_default_model_delete': 'Default models cannot be deleted. \nTo delete this Model, set another model as the Default model, then return to this model\'s settings and select delete.',
    't_no_results': 'No results found.',
    't_no_graph_data': 'No graph data',
    't_getting_scope_data': 'Getting Scope Data...',
    't_creating_default_scope': 'Creating default scope...',
    't_rise_over_previous_period': 'rise over previous period',
    't_sort': 'Sort',
    't_lowest_first': 'Lowest first',
    't_highest_first': 'Highest first',
    't_nzc_data_missing': 'Data missing',
    't_nzc_carbon_intensity': 'Carbon intensity',
    't_current_action_plan': 'Current Action Plan',
    't_current_epc_analysis': 'Current EPC Analysis',
    't_sold': 'SOLD',
    't_data_warning': 'DATA WARNING',
    't_siera_experience_feedback': 'I\'d be happy to speak in more depth about my experience of using SIERA',
    't_assets_not_in_model': 'assets are not included in this NZC model',
    't_reason_assets_not_in_model': 'These may include assets that have been sold, failed NZC validation or manually removed from the model.',
    't_view_these_assets': 'View these assets',
    't_export_model_explanation_text': 'You can manually change the utility consumption amounts for each asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_model_explanation_text_asset': 'You can manually change the utility consumption amounts for an asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_file_error_message': 'The export file name must not contain more than 50 characters',
    't_top': 'Top',
    't_import_model_explanation_text': 'To import asset data from Excel you must use the {0} template',
    't_import': 'Import',
    't_drag_file': 'Drag file to upload, or',
    't_select_file': 'Select a file',
    't_import_create_explanation': 'What do you want the new NZC model to be called?',
    't_upload_success_msg': 'has been successfully uploaded',
    't_upload_error_msg': 'There are problems with your file',
    't_row': 'Row',
    't_copy_clipboard': 'Copy to clipboard',
    't_select_valid_file': 'Select a valid file',
    't_copied': 'Copied',
    't_loading': 'Loading',
    't_procurement_tabs_explanation_title': 'What do these categories mean?',
    't_data_categories': 'Data Categories',
    't_about_procurement_data_categories': '<p><b>Actual:</b> consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_duplicate_model_para': 'This will create a duplicate model with all of the assets from the current model. Any assets which do not have enough consumption data will have a sector and country benchmark applied.',
    't_asset_level_duplicate_model_para': 'This will create a duplicate model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_delete_target_pathway_title': 'Delete Target Pathway',
    't_delete_target_pathway_message': 'Are you sure you want to delete this pathway?',
    't_add_another_target_pathway': 'Add another Target Pathway',
    't_add_a_target_pathway': 'Add a Target Pathway',
    't_target_pathway': 'Target pathway',
    't_milestone_years': 'Milestone years',
    't_group_leaving_confirmation': 'Thanks, Admin have been sent your request and we will be back in touch shortly',
    't_group_reason': 'What is your reason for leaving the group?',
    't_request': 'Request',
    't_leave_group': 'Request to leave the group',
    't_add_group': 'Create new Group',
    't_target_warning': 'The cumulative amount is 100% and cannot be increased. Please revise the reduction percentages.',
    't_chart_options': 'Chart options',
    't_siera': 'SIERA',
    't_imported': 'Imported',
    't_plot_data_assets': 'Plot data for individual assets',
    't_display_benchmark': 'Display benchmark',
    't_data_source': 'Data source',
    't_show_progress_relative': 'Show progress relative to target for',
    't_base_line_year': 'Baseline year',
    't_raw_data': 'Raw data',
    't_uplifted_data': 'Uplifted data',
    't_uplifted_estimated_data': 'Uplifted/estimated data',
    't_complete_data': 'Complete data',
    't_benchmark_data': 'Benchmarked data',
    't_choose_assets_group_for_update_user': 'Choose assets to include in ‘{0}’',
    't_choose_assets_group_for_new_user': 'Choose assets for this group to access',
    't_previous_period': 'Previous period',
    't_this_period': 'This period',
    't_gap_filled': 'Gap filled',
    't_combined': 'Combined',
    't_actual_and_supplier_estimated': 'Actual & supplier estimated',
    't_recycled_waste': 'Recycled waste',
    't_recycled_waste_previous': 'Recycled waste (previous)',
    't_group_name': 'Group name',
    't_email_leave_group': 'To request to leave this group, please email',
    't_data_shown': 'Data shown',
    't_show_details': 'Show details',
    't_hide_details': 'Hide details',
    't_view_asset': 'View asset',
    't_gia_small_form': 'GIA',
    't_asset_ref': 'Asset ref',
    't_stranding_year': 'CRREM Misalignment year',
    't_energy_saving': 'Energy-saving actions',
    't_next_users': 'Next - Choose Users',
    't_delete_group_msg': 'Are you sure you want to delete this group?',
    't_edit_group': 'Edit group : ',
    't_all_assets': 'All assets',
    't_not_included_in_model': 'Not included in current NZC model',
    't_including_gap_filled': 'Including gap-filled data',
    't_excluding_gap_filled': 'Excluding gap-filled data',
    't_asset_without_energy_saving_action': 'Assets with no energy saving actions specified',
    't_sold_assets': 'Sold assets',
    't_sold_label': 'Asset sold',
    't_asset_status': 'Asset status',
    't_no_data_for_previous_period': 'no data for previous period',
    't_x_axis_scale': 'X-axis scale',
    't_y_axis_scale': 'Y-axis scale',
    't_autoscale': 'Autoscale',
    't_from': 'From',
    't_to': 'to',
    't_min': 'Min',
    't_max': 'Max',
    't_selected_asset': 'Selected asset',
    't_no_gresb_sector_error_message': 'Asset has no GRESB Sector or Country defined',
    't_asset_data_missing_message': 'Asset has critical information missing',
    't_asset_sold_date_message': 'Asset sold in',
    't_more_recycled': 'more recycled than previous period',
    't_less_recycled': 'less recycled than previous period',
    't_required_group_field': 'Required field',
    't_form_group_error_message': 'Please fill the required field',
    't_upload_nzc_data_failed': 'Upload NZC import data failed',
    't_nzc_file_uploaded_success': '{0} file successfully uploaded',
    't_default_model_name': 'Default model',
    't_metric': 'Metric',
    't_imperial': 'Imperial',
    't_energy_intensity_popup_header': 'Coming soon',
    't_energy_intensity_popup_body': 'Detailed performance view for Energy Intensity coming soon.',
    't_epc_analysis_popup_header': 'Coming soon',
    't_epc_analysis_popup_body': '<p>Detailed EPC analysis will be available soon and is currently  <a>available in SIERA </a> </p>',
    't_model_notes': 'Model notes',
    't_setting_default_model_failed': 'Setting model as default failed',
    't_set_as_default': 'Set as Default Model',
    't_set_as_default_info': 'This is the model that is displayed on the fund dashboard, and will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_set_as_default_asset_info': 'This will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_nzc_default_text': 'NZC default',
    't_unable_to_plot_NZC_chart': 'Unable to plot NZC chart.',
    't_unable_to_plot_NZC_chart_Info': 'No valid assets are available. Assets in this fund must have GRESB Sector and Country defined in order to be included in NZC calculations.',
    't_unable_to_plot_require_help': 'Please {contactEvora} if you require help.',
    't_contact_Evora': 'contact Evora',
    't_Contact_Evora': 'Contact Evora',
    't_model_no_data_available': 'No data available',
    't_select_target_pathway': 'Select Target Pathway',
    't_define_target_pathway': 'Define a custom target pathway',
    't_name_must_not_exceed_100_characters': 'The model name must not contain more than 100 characters',
    't_no_meter_information': 'No meter information.',
    't_no_assets': '0 assets',
    't_show_stranding_dates': 'Show CRREM Misalignment dates',
    't_default': 'Default',
    't_current_model': 'Current model',
    't_based_on': 'Based on',
    't_past_3_months': 'Past 3 months',
    't_past_6_months': 'Past 6 months',
    't_current_year_till_previous_month': 'Current year till previous month',
    't_model_with_same_name_exists': 'Model with the same name already exists.',
    't_apply_filter_view_these_assets': 'Apply Filter to view these assets',
    't_session_expiry_warning': 'For security reasons, we\'ll log you out in {0} unless you want to stay logged in.',
    't_session_expiry_title': 'Do you want to stay logged in?',
    't_stay_logged_in': 'Stay logged in',
    't_log_out_now': 'Log out now',
    't_jpeg': 'JPEG',
    't_svg': 'SVG',
    't_currency': 'Currency',
    't_nzc_session_model_deleted': '{0} was deleted and cannot be displayed.  You are now viewing the default NZC model instead.',
    't_session_expiry': 'Your session is going to expire soon. Would you like to log out?',
    't_estimated_savings': 'Estimated Savings',
    't_procured_by': 'Procured by',
    't_area_covered': 'Area Covered',
    't_shared_services': 'Shared services',
    't_scope_index': 'Scope {0}',
    't_import_model_explanation_note_link': 'To import asset data from Excel you must use the {link} template.',
    't_import_model_explanation_note_description': 'Uploaded data is only used in the new NZC model that is created - it does not overwrite any data currently in SIERA',
    't_import_model_explanation_note_foundName': 'You can only upload data for assets that belong to the {fundOrAssetName} fund',
    't_btn_add': 'Add',
    't_btn_update_and_add': 'Update and add',
    't_gresb_measure_water': 'Performed a technical building assessment to identify water efficiency improvements',
    't_gresb_measure_waste': 'Performed a technical building assessment to identify waste efficiency improvements',
    't_gresb_measure_energy': 'Performed a technical building assessment to identify energy efficiency improvements',
    't_nzc_data_availability': 'Data availability',
    't_valid_ratings_by_floor_area': 'Valid scores by floor area',
    't_certified_assets_by_floor_area': 'Certified assets by floor area',
    't_ratings_last_sync_on': 'Scores last synced on {0}',
    't_certified': 'certified',
    't_energy_star_analysis': 'Energy Star Analysis',
    't_energy_star_score': 'Energy Star Score',
    't_energy_star_last_synced': 'This score was last synced from Energy Star Portfolio Manager on {0}.',
    't_kg_co2_m2_yr': 'kgCO₂e/m²/yr',
    't_kg_co2_yr': 'kgCO₂e/yr',
    't_kWh_m2_yr': 'kWh/m²/yr',
    't_energy_star_set': 'Set up your Energy Star integration to get this data',
    't_post_note_warning_message': 'Hit Post to add your note before closing',
    't_energy_star_integration': 'Energy Star Integration',
    't_es_sub_text': 'Integrating SIERA with your Energy Star Portfolio Manager will allow SIERA to extract and display energy ratings for your Assets.',
    't_learn_more': 'Learn more',
    't_es_step_title': 'Step {0} of {1}: {2}',
    't_es_step_one': 'Log into ES Portfolio Manager and add Evora_Siera as a contact',
    't_es_step_two': 'Enter your ES Portfolio Manager account ID',
    't_es_step_three': 'Share properties in ES Portfolio Manager with full access',
    't_es_step_four': 'Choose which Assets to extract ratings for',
    't_es_step_one_sub_text': '{0} and add Evora_Siera as a new contact.',
    't_es_login_pf_manager': 'Log into your Energy Star Portfolio Manager',
    't_es_prompted_username': 'When prompted, enter “Evora_Siera” as the username.',
    't_es_add_contact_button': 'I have added Evora_Siera as a contact',
    't_es_requested_account_text': '{0}\'s Energy Star Portfolio Manager account has requested to connect with your SIERA account.',
    't_es_account_id': 'Enter your ES Portfolio Manager account ID. You can find this in your ES Portfolio Manager account settings.',
    't_es_confirm_connection': 'Confirm connection',
    't_es_not_recognise_request': 'If you don\'t recognise this request, please select cancel.',
    't_es_account_sharing': 'Head back to your Energy Star Portfolio Manager account and go to {0}.',
    't_es_sharing': 'Sharing',
    't_es_select_share': 'Select \'share with your utility or service provider\' and share properties with SIERA.',
    't_es_set_props_full_access': 'Please ensure you are setting properties to full access.',
    't_es_i_have_set_up_sharing': 'I have set up sharing',
    't_es_available_assets': 'These are available Assets we found matches for in your Energy Star Portfolio Manager account. Please select the Assets you would like to extract ratings for and check that our suggested match is correct.\n',
    't_es_change_permission_and_support': 'If you do not see an Asset you would like to import data for, you may need to change permissions in your ES Portfolio Manager account or {0}. ',
    't_es_contact_support': 'Contact Support',
    't_es_confirm': 'Confirm',
    't_es_asset_in_siera': 'Asset in SIERA',
    't_es_asset_in_portfolio_manager': 'Respective Asset in ES Portfolio Manager',
    't_es_success': 'You can now view the Energy Star ratings for successfully matched Assets in SIERA.',
    't_success': 'Success',
    't_continue': 'Continue',
    't_action_based_pathway_stranding': 'Action-based pathway CRREM Misalignment in',
    't_fund_carbon_intensity': 'Fund carbon intensity',
    't_fund_energy_intensity': 'Fund energy intensity',
    't_es_step_three_error': 'Error: We couldn\'t find shared properties from your ES Porfolio Manager account.\n Please make sure you have set up sharing with full access.',
    't_es_step_two_error': 'Error: We couldn\'t find a request from the account ID you entered.\n Please check the ID is correct and try again.',
    't_es_step_one_error': 'Error: Please make sure you have added SIERA as a contact before proceeding.',
    't_es_api_error': 'Error: Contacting the Energy Star Portfolio Manager is not possible at the moment. Please try again later.\n If the error continues to happen, please contact support.',
    't_year_from_to_4_digits': 'Ensure year To is not less than year From (Please note 4 digits must be entered in these boxes)',
    't_min_max_numeric': 'Ensure maximum value is greater than minimum value (Numeric only)',
    't_es_matched_assets_info': 'These are the Assets in your SIERA account that have been matched with properties in your Energy Star Portfolio Manager. You can view Energy Star Ratings for these Assets in SIERA.',
    't_es_matched_assets_count': '{0} of {1} Assets matched',
    't_es_sync_frequency': 'Sync frequency',
    't_es_match_more_assets': 'Match more Assets',
    't_address': 'Address',
    't_last_sync': 'Last Sync',
    't_jpeg_small': 'Small JPEG',
    't_png_small': 'Small PNG',
    't_jpeg_medium': 'Medium JPEG',
    't_png_medium': 'Medium PNG',
    't_jpeg_large': 'Large JPEG',
    't_png_large': 'Large PNG',
    't_max_length_30': 'Custom pathway maximum character length is 30 characters',
    't_unique_pathway_name': 'The custom pathway name must be unique',
    't_tp_name_validation': 'Name can only contain numbers & letters',
    't_monthly': 'Monthly',
    't_yearly': 'Yearly',
    't_mean_carbon_intensity': 'Mean carbon intensity',
    't_data_availability_assets': 'Data availability of assets',
    't_uplifted': 'Uplifted',
    't_benchmark': 'Benchmarked',
    't_target_pathway_2': 'Target Pathway 2',
    't_target_pathway_3': 'Target Pathway 3',
    't_unique_custom_target_pathway_name': 'Custom pathway name must be unique',
    't_tp_name_empty': 'Custom pathway name cannot be empty',
    't_example': 'E.g.',
    't_no_assets_to_match': 'No assets to match.',
    't_intensity': 'Intensity',
    't_portfolio_excel': 'SIERA Portfolio.xlsx',
    't_excel_tab_name': 'Assets Raw Data',
    't_add_details': 'Add details',
    't_client_name': 'Client',
    't_agent_name': 'Agent',
    't_purchase_date': 'Purchase date',
    't_sale_date': 'Sale date',
    't_property_status': 'Property Status',
    't_gresb_sector': 'GRESB sector',
    't_gresb_management_status': 'GRESB management status',
    't_gia_m_sqrt': 'GIA (m2)',
    't_nla_m_sqrt': 'NLA (m2)',
    't_cpa_m_sqrt': 'CPA (m2)',
    't_is_cpa_estimated': 'Is CPA estimated?',
    't_gas_expected': 'Gas expected',
    't_water_expected': 'Water expected',
    't_electricity_expected': 'Electricity expected',
    't_oil_expected': 'Oil expected',
    't_district_heating_expected': 'District heating expected',
    't_district_cooling_expected': 'District cooling expected',
    't_fund_performance_excel': 'SIERA Fund Performance.xlsx',
    't_view_nzc_tp_for_asset': 'View detailed NZC pathways for this asset',
    't_fund_carbon_performance_report': 'Fund Carbon Performance Report',
    't_fund_electricity_performance_report': 'Fund Electricity Performance Report',
    't_fund_thermals_performance_report': 'Fund Gas, Fuels & Thermals Performance Report',
    't_fund_waste_performance_report': 'Fund Waste Performance Report',
    't_fund_water_performance_report': 'Fund Water Performance Report',
    't_fund_level_summary': 'Fund Level Summary',
    't_total_consumption_excel': 'Total Consumption (MWh)',
    't_asset_level_total_consumption_excel': 'Total Consumption ({0})',
    't_total_emission_excel': 'Total Emissions ({0})',
    't_total_consumption': 'Total Consumption ({0})',
    't_total_carbon_emission_excel': 'Total Carbon Emission (T)',
    't_gap_filled_data_excel': 'Gap Filled Data (%)',
    't_over_under_target_excel': 'Over/Under target (%)',
    't_time_period_excel': 'Time Period',
    't_asset_information_excel': 'Asset Information',
    't_floor_area_excel': 'Floor Area (m2)',
    't_floor_area_excel_imperial': 'Floor Area (ft2)',
    't_occupancy_excel': 'Occupancy (%)',
    't_intensity_excel': 'Intensity ({0})',
    't_carbon_intensity_excel': 'Carbon intensity ({0})',
    't_recycled_waste_excel': 'Recycled Waste (t)',
    't_total_waste_excel': 'Total Waste (t)',
    't_recycled_percentage_excel': '% Recycled',
    't_recycled_percentage_change_excel': '% change in recycled waste',
    't_post_code': 'Post code',
    't_interim_target': 'Interim target',
    't_month_to_end_of': 'month to end of', // to be updated
    't_months_to_end_of': 'months to end of', // to be updated
    't_energy_intensity_excel': 'Energy Intensity (m3/m2)',
    't_title_update_target_pathway_failed': 'Update target pathway failed',
    't_title_delete_target_pathway_failed': 'Delete target pathway failed',
    't_ton_co2_yr': 'tCO₂e/yr',
    't_average_carbon_intensity': 'Average carbon intensity',
    't_average_energy_intensity': 'Average energy intensity',
    't_average_cost_intensity': 'Average cost intensity',
    't_performance_assets_model': 'Performance for assets used in model',
    't_energy_intensity_nzc': 'Energy intensity',
    't_selected_utility_excel': '{0} - EXCEL',
    't_all_utilities_excel': 'All utilities - EXCEL',
    't_gas_fuels_thermals': 'Gas, fuels and thermals',
    't_total_energy_consumption': 'Total energy consumption (MWH)',
    't_fund_performance_report': 'Fund Performance Report',
    't_energy_summary': 'Energy Summary',
    't_remove_match': 'Remove match',
    't_remove': 'Remove',
    't_action_by_impact_excel': 'Actions by impact - EXCEL',
    't_action_by_status_excel': 'Actions by status - EXCEL',
    't_es_reset_warning_message_one': 'Cancelling will take you back to Step 1.',
    't_es_reset_warning_message_two': 'Are you sure you want to cancel the integration {0} set up process?',
    't_es_reset_warning_header_message': 'Cancel integration set up process',
    't_es_reset_warning_yes': 'Yes, cancel',
    't_es_reset_warning_no': 'Stay on Step 4',
    't_tenant_data_quality': 'Tenant data quality',
    't_landlord_data_quality': 'Landlord data quality',
    't_tenant_procured_assets': 'Tenant procured assets',
    't_landlord_procured_assets': 'Landlord procured assets',
    't_actual_percentage': 'Actual (%)',
    't_supplier_estimated_percentage': 'Supplier estimated (%)',
    't_incomplete_percentage': 'Incomplete (%)',
    't_not_covered_percentage': 'Not covered (%)',
    't_total_missing_percentage': 'Total missing (%)',
    't_managing_agent': 'Managing agent',
    't_portion_of_missing_fund_data_percentage': 'Portion of missing fund data (%)',
    't_dq_floor_area_landlord': 'Maximum landlord floor area ({0})',
    't_dq_floor_area_tenant': 'Maximum tenant floor area ({0})',
    't_dq_floor_area_without_data': 'Floor area for which you have no data ({0})',
    't_dq_floor_area': 'Floor area ({0})',
    't_fund_data_quality_excel': 'Fund Data Quality Excel',
    't_fund_data_quality_report': 'Fund Data Quality Report',
    't_upload_consumption_data': 'Upload consumption data',
    't_upload_action_plans': 'Upload action plans',
    't_action_plan_point_two': 'Upload actions data',
    't_consumption_upload_sub_text': 'Uploading consumption data will improve your data completeness scores and help you accurately track your sustainability goals. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to submit consumption data.',
    't_action_plan_sub_text': 'You can manage significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload/edit action plans in bulk.',
    't_consumption_upload_template_point_one': 'Generate and populate your consumption template',
    't_action_plan_upload_template_point_one': 'Generate and populate your template\n',
    't_consumption_upload_point_one_subtext': 'Populate the template with your consumption data. The template has been partially populated to help you get the data in the right place.',
    't_action_plan_upload_point_one_subtext': 'Populate the template with your list of actions. The template has been partially populated to help you get the data in the right place.',
    't_download_template': 'Generate template',
    't_upload_template': 'Upload template',
    't_action_plan_upload_point_two_subtext': 'When you upload your completed template, you will be guided through an error handling process.',
    't_consumption_upload_success_title': 'Data upload successful',
    't_consumption_upload_success_text_one': 'Consumption has been uploaded for {0} meters. Uploaded on {1} by {2}.',
    't_consumption_upload_success_text_two': 'Your data will be available to view on the performance pages within 15 minutes. We\'ll send you an email when it\'s ready.',
    't_action_upload_success_text_one': '{0} action plans have been uploaded. Uploaded on {1} by {2}',
    't_action_upload_success_text_two': 'Your data will be available to view on each asset\'s action plan page. We\'ll send you an email when its ready',
    't_action_upload_single_asset_success_text_one': 'Actions has been uploaded for {0}. Uploaded on {1} by {2}',
    't_consumption_upload_error_title': 'Data upload unsuccessful',
    't_consumption_upload_error_text_one': 'We\'re sorry, something\'s gone wrong.',
    't_consumption_upload_error_text_two': 'Your upload has been unsuccessful. Please {0} or try again.',
    't_return_home': 'Return home',
    't_return_action':'Return to Actions',
    't_upload_bulk_consumption': 'Bulk add consumption',
    't_upload_bulk_action_plan': 'Bulk add/edit actions',
    't_upload_bulk_consumption_assets_warning_button_back': 'OK, back',
    't_upload_bulk_consumption_assets_warning_button_agree': 'Upload anyway',
    't_upload_bulk_consumption_assets_warning': 'You\'re about to upload consumption data to a very large list of assets. We would recommend filtering your asset list to make your upload template more manageable.',
    't_fund_action_plan_report': 'Action Plan Report',
    't_total_agreed_actions': 'Total agreed actions',
    't_un_costed_actions': 'Un-costed actions',
    't_unit_of_measurement': 'Unit of measurement',
    't_overdue_actions': 'Overdue actions',
    't_under_review_actions': 'Actions under review',
    't_fund_agreed_actions_summary': 'Fund level summary of agreed actions',
    't_fund_overdue_actions_summary': 'Fund level summary of overdue actions',
    't_fund_completed_actions_summary': 'Fund level summary of completed actions',
    't_fund_applicable_actions_summary': 'Fund level summary of applicable actions',
    't_fund_under_review_actions_summary': 'Fund level summary of actions under review',
    't_fund_action_plan_status_excel': 'Fund ActionPlan (by status)',
    't_no_fund_actions_with_status': 'This fund has no actions with this status',
    't_actions_per_year': 'Actions per year',
    't_asset_performance_excel': 'Asset performance EXCEL',
    't_gas_fuels_performance': 'Gas, Fuels & Thermals performance report',
    't_water_performance': 'Water performance report',
    't_waste_performance': 'Waste performance report',
    't_carbon_performance': 'Carbon performance report',
    't_asset_performance_export': 'Asset performance export from portfolio view',
    't_asset_gas_fuels_thermals': 'Gas, fuels & thermals',
    't_total_energy_consumption_kwh': 'Total energy consumption (KWH or MWH)',
    't_gap_filled_energy_data': 'Gap-filled energy data (%)',
    't_current_energy_consumption': 'Current energy consumption (KWH)',
    't_generate_your_template': 'Generate your consumption template',
    't_generate_your_action_plan_template': 'Generate your action plan template',
    't_asset_details_excel': 'Asset details EXCEL',
    't_no_data_to_export': 'No data available to export',
    't_total_carbon_emissions': 'Total Carbon Emissions ({0})',
    't_landlord_summary': 'Landlord summary',
    't_tenant_summary': 'Tenant summary',
    't_dq_floor_area_gia': 'Floor area ({0}) GIA',
    't_fund_action_plan_impact_excel': 'Fund ActionPlan (by impact)',
    't_total_actions_for_category': 'Total actions in this category',
    't_fund_actions_bio_diversity_impact_summary': 'Fund level summary of actions with biodiversity impact',
    't_fund_actions_building_performance_impact_summary': 'Fund level summary of actions with building performance impact',
    't_fund_actions_community_engagement_impact_summary': 'Fund level summary of actions with community engagement impact',
    't_fund_actions_energy_impact_summary': 'Fund level summary of actions with energy impact',
    't_fund_actions_governance_recommended_impact_summary': 'Fund level summary of actions with governance recommended impact',
    't_fund_actions_health_wellbeing_impact_summary': 'Fund level summary of actions with health & wellbeing impact',
    't_fund_actions_social_value_impact_summary': 'Fund level summary of actions with social value impact',
    't_fund_actions_tenant_engagement_impact_summary': 'Fund level summary of actions with tenant engagement impact',
    't_fund_actions_waste_impact_summary': 'Fund level summary of actions with waste recycling impact',
    't_fund_actions_water_impact_summary': 'Fund level summary of actions with water impact',
    't_fund_actions_other_impact_summary': 'Fund level summary of actions with other impact',
    't_actions_with_bio_diversity_impact_title': 'Actions with biodiversity impact',
    't_actions_with_building_performance_impact_title': 'Actions with building performance impact',
    't_actions_with_community_engagement_impact_title': 'Actions with community engagement impact',
    't_actions_with_energy_impact_title': 'Actions with energy impact',
    't_actions_with_governance_recommended_impact_title': 'Actions with governance recommended impact',
    't_actions_with_health_wellbeing_impact_title': 'Actions with health & wellbeing impact',
    't_actions_with_social_value_impact_title': 'Actions with social value impact',
    't_actions_with_tenant_engagement_impact_title': 'Actions with tenant engagement impact',
    't_actions_with_waste_impact_title': 'Actions with waste recycling impact',
    't_actions_with_water_impact_title': 'Actions with water impact',
    't_actions_with_other_impact_title': 'Actions with other impact',
    't_fund_level_energy_summary': 'Fund level energy summary',
    't_asset_information': 'Asset information',
    't_total_floor_area_m2': 'Total Floor Area (m2)',
    't_tenant_controlled_asset': 'Tenant Controlled Asset',
    't_current_year_carbon_emissions_kg': 'Current Year Carbon Emissions (kg)',
    't_current_year_energy_consumption_kwh': 'Current Year Energy Consumption (KWH)',
    't_previous_year_carbon_emissions_kg': 'Previous Year Carbon Emissions (kg)',
    't_previous_annual_consumption_kwh': 'Previous annual consumption (KWH)',
    't_intensity_unit': 'Intensity ({0})',
    't_benchmark_kwh/m2': 'Benchmark (kWh/m2)',
    't_benchmark_m3/m2': 'Benchmark (m3/m2)',
    't_landfill_unit': 'Landfill ({0})',
    't_incinerated': 'Incinerated ({0})',
    't_recycled_unit': 'Recycled ({0})',
    't_reuse_unit': 'Reuse ({0})',
    't_anaerobic_t': 'Anaerobic (t)',
    't_hazardous_t': 'Hazardous (t)',
    't_unknown_unit': 'Unknown ({0})',
    't_total_t': 'Total (t)',
    't_energy_performance_report': 'Energy Performance Report',
    't_electricity_performance_report': 'Electricity Performance Report',
    't_gas_fuels_thermals_report': 'Gas, Fuels & Thermals Performance Report',
    't_water_performance_report': 'Water Performance Report',
    't_waste_performance_report': 'Waste Performance Report',
    't_carbon_performance_report': 'Carbon Performance Report',
    't_unsaved_changes': 'Unsaved changes',
    't_unsaved_changes_message': 'Do you want to save the changes to the model before navigating away?',
    't_leave_without_saving': 'Leave without saving',
    't_save_and_leave': 'Save and leave',
    't_support_guides': 'Support Guides',
    't_release_notes': 'Release Notes',
    't_asset_performance_report': 'Asset Performance Report',
    't_is_the_asset_tenant': 'Is the asset tenant controlled?',
    't_current_consumption': 'Current consumption',
    't_current_year_gap': 'Current year gap filled Data (%)',
    't_previous_annual_consumption': 'Previous annual consumption',
    't_previous_year_gap': 'Previous Year Gap Filled Data (%)',
    't_unit_of_measurement_for_consumption': 'Unit of measurement for consumption',
    't_benchmark_name': 'Benchmark',
    't_unit_of_measurement_for_intensity': 'Unit of measurement for intensity',
    't_kwh_m2': 'kWh/m2',
    't_m3': 'm3',
    't_m3_m2': 'm3/m2',
    't_kg_co2_m2': 'kg CO2e/m2',
    't_current_total_waste': 'Current Total Waste (t)',
    't_current_recycled_waste': 'Current Recycled Waste (t)',
    't_current_recycled': 'Current % Recycled',
    't_previous_total_waste': 'Previous Total Waste (t)',
    't_previous_recycled_waste': 'Previous Recycled Waste (t)',
    't_previous_recycled': 'Previous % Recycled',
    't_agreed_and_applicable_actions': 'Agreed and applicable actions',
    't_generate_template_user_text': 'The following will specify how your template is pre-populated.\nDon\'t worry, you\'ll still be able to edit the spreadsheet as you\nsee fit.',
    't_type_of_record': 'Type of record',
    't_template_to_generate': 'Template to generate',
    't_time_period': 'Time period',
    't_time_period_user_text': 'The template will only include date ranges for gaps in your consumption data, within your specified time period',
    't_meters_included_template': 'Meters included in template',
    't_file_name': 'File name',
    't_include_inactive_meters': 'Include inactive meters',
    't_generate': 'Generate',
    't_landlord_procured_meters': 'Landlord procured meters',
    't_tenant_procured_meters': 'Tenant procured meters',
    't_both': 'Both',
    't_asset_action_plans_excel': 'Asset action plans EXCEL',
    't_asset_data_quality_excel': 'Asset data quality EXCEL',
    't_benchmark_line': 'Benchmark line',
    't_no_benchmark': 'No Benchmark',
    't_benchmark_office_ac': 'BBP REEB Office A/C Typical Practice',
    't_benchmark_sc_ac': 'BBP REEB Enclosed SC A/C Typical Practice',
    't_consumption_upload': 'consumption upload',
    't_action_upload': 'action upload',
    't_bulk_consumption_instruction_header': 'SIERA Consumption Data Upload Template',
    't_bulk_action_plan_instruction_header': 'SIERA Actions Plan Add in Bulk Template',
    't_bulk_action_plan_edit_instruction_header': 'SIERA Actions Plan Edit in Bulk Template',
    't_bulk_consumption_instruction_note': 'Please note:',
    't_bulk_consumption_instruction_one': 'The submission of consumption data will contribute to your data quality and data completeness scores.',
    't_bulk_consumption_instruction_two': 'In order to upload consumption to SIERA, please populate sheet 2 of this spreadsheet (labelled \'consumption loader\') with your consumption figures. Then, upload the spreadsheet to SIERA on the same page you found this template.',
    't_bulk_consumption_instruction_three': 'We have pre-populated some of the columns for you, to help you populate the template from your internal records. Please feel free to change or add new date ranges according to the dates you have consumption records for, but please do not add any new columns and do not edit the meter ID column as we need exact ID\'s to add consumption to those meters.',
    't_bulk_consumption_instruction_four': 'Green headers indicate mandatory fields, whereas blue headers indicate optional fields.',
    't_bulk_consumption_instruction_six': 'We have only included meters in the template which we do not have a full set of consumption data for. If for whatever reason you need to override existing consumption records, please enter the exact date range for the consumption you want to override.',
    't_bulk_consumption_instruction_five': 'This template does not allow you to edit meter or asset characteristics. You will only be able to upload consumption data. To make any changes to asset or meter characteristics, please get in touch with an EVORA consultant or customer support.',
    't_bulk_consumption_instruction_seven': 'If the meter you are trying to upload consumption for is not listed on the template, you may not have access to upload consumption for this meter, or it may not exist on the system. Please get in touch with an EVORA consultant or our customer service team if you need to add a new meter before you upload consumption for that meter.',
    't_bulk_consumption_instruction_eight': 'If you require extra guidance on what a field means, you can click on the column and see a description of what the system requires for that field.',
    't_bulk_action_plan_instruction_one': 'This template will allow you to bulk Add Action Plans.',
    't_bulk_action_plan_edit_instruction_one': 'This template will allow you to bulk edit Action Plans.',
    't_bulk_action_plan_instruction_two': 'In order to add Actions in bulk, please go to sheet called "Bulk Add Template" under this file with all the relevant actions.',
    't_bulk_action_plan_edit_instruction_two': 'In order to edit Actions in bulk, please go to sheet called "Bulk Edit Template" under this file with all the relevant actions.',
    't_bulk_action_plan_instruction_three': 'Asset Reference Column has a list of all your assets within the fund, select the one you want the action to added to, if you downloaded the template from an Asset you will only get the individual asset.',
    't_bulk_action_plan_instruction_four': 'Each row represents an action, to add multiple to the same asset please select the same "Asset Reference in a new row"',
    't_bulk_action_plan_instruction_five': 'Columns highlighed in green are required, blue are optional.',
    't_bulk_action_plan_instruction_six': 'Once populated please reupload the filled in file back into SIERA.',
    't_bulk_action_plan_instruction_seven': 'If you require further guidance on each of the fields, click the header of the column for more information.',
    't_bulk_consumption_tooltip_asset_name': 'This is the name of the asset. Don’t see an asset or meter you need to add consumption for? Contact SIERA team to add it to the system.',
    't_bulk_consumption_tooltip_utility': 'The utility type this meter is associated with.',
    't_bulk_action_plan_edit_tooltip_actionId': 'DO NOT EDIT THIS',
    't_bulk_consumption_tooltip_area_covered': 'The area of the property which this meter covers.',
    't_bulk_consumption_tooltip_is_active': 'Is this meter active or inactive',
    't_bulk_consumption_tooltip_serial_number': 'The meter’s serial number',
    't_bulk_consumption_tooltip_meter_name': 'The meter name in SIERA. This should match up with your internal notes, so you can easily find which meter this refers to.',
    't_bulk_consumption_tooltip_from_date': 'The start date of this consumption record, in the format dd/mm/yyyy. We have populated the dates for which we do not have consumption data in the system, but feel free to replace these dates if you do not have data for the full date range.',
    't_bulk_consumption_tooltip_to_date': 'The end date of the consumption record, in the format dd/mm/yyyy',
    't_bulk_consumption_tooltip_origin': 'The origin of the consumption figure, eg. invoices or meter readings',
    't_bulk_consumption_tooltip_consumption': 'Please enter your consumption. We cannot accept meter readings at this time. Remove any commas or decimal places. Energy must be in kWh and water in m3.',
    't_bulk_consumption_tooltip_estimated': 'Is this consumption figure estimated or actual',
    't_bulk_action_plan_tooltip_assetReference': 'Select the asset you would like to add the action to, each row represents an action. So if you want to add multiple actions to the same asset please ensure you select it for each row.',
    't_bulk_action_plan_tooltip_gresbefficiency': 'Please ensure you select the GRESB Efficiency Measure if you have selected any of the following Impacts: Energy, Water and Waste.',
    't_bulk_action_plan_tooltip_cost': 'Please just enter the amount without currency characters.',
    't_bulk_action_plan_tooltip_currency': 'Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityType': 'Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityChange': 'Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_bulk_action_plan_tooltip_primaryUtilityCostChange': 'Enter the amount of cost changes, currency dropdown applies to these fields, so only the amounts will be necessary.',
    't_bulk_action_plan_tooltip_secondaryUtilityChange': 'Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_import_model_explanation_note_asset_name': 'You can only upload data related to {fundOrAssetName} asset',
    't_evoranzcdata': 'EvoraNZCData',
    't_summary': 'Summary',
    't_asset_performance_excel_file_name': 'SIERA Asset Performance Excel',
    't_total_energy_consumption_excel_mwh': 'Total Energy Consumption (MWh)',
    't_total_energy_consumption_excel_kwh': 'Total Energy Consumption (KWh)',
    't_action_export_from_portfolio_view': 'Actions export from portfolio view',
    't_summary_of_agreed_action': 'Summary of agreed actions',
    't_total_overdue_action': 'Total overdue actions',
    't_total_completed_action': 'Total completed actions',
    't_total_applicable_action': 'Total applicable actions',
    't_total_action_under_review': 'Total actions under review',
    't_action_estimated_savings': 'Estimated savings',
    't_action_area_covered': 'Area covered',
    't_summary_of_overdue_action': 'Summary of overdue actions',
    't_summary_of_completed_actions': 'Summary of completed actions',
    't_summary_of_applicable_actions': 'Summary of applicable actions',
    't_summary_of_actions_under_review': 'Summary of actions under review',
    't_no_assets_selected_actions_status': 'The assets selected have no actions with this status',
    't_missing_fund_data_weighted_by_floor_area': 'Missing fund data, weighted by floor area (%)',
    't_floor_area_for_no_data': 'Floor area not covered ({0})',
    't_floor_area_not_covered_percentage': 'Floor area not covered (%)',
    't_portfolio_data_quality_report': 'Data Quality Report',
    't_portfolio_data_quality_file_name': 'Portfolio Data Quality Report',
    't_current_energy_consumption_kwh': 'Current Energy Consumption (kWh)',
    't_level_of_details_by_asset': 'By asset',
    't_level_of_details_by_meter': 'By meter',
    't_time_period_granularity_annual': 'Annual',
    't_time_period_granularity_monthly': 'Monthly',
    't_level_of_detail': 'Level of detail',
    't_time_period_granularity': 'Time period granularity',
    't_name_must_not_exceed_50_characters': 'The model name must not contain more than 50 characters',
    't_utility_meter_unavailable': 'Unavailable: no meter for',
    't_current_reporting_period_total_energy_consumption': 'Current Reporting Period Total Energy Consumption ({0})',
    't_current_reporting_gap_filled_energy_data_percentage': 'Current Reporting Gap-filled Energy Data (%)',
    't_previous_reporting_period_total_energy_consumption': 'Previous Reporting Period Total Energy Consumption ({0})',
    't_previous_reporting_gap_filled_energy_data_percentage': 'Previous Reporting Gap-filled Energy Data (%)',
    't_total_asset_floor_area': 'Total Asset Floor Area ({0})',
    't_reporting_period': 'Reporting Period',
    't_reporting_period_gap_filler_data_percentage': 'Reporting Period Gap Filled Data (%)',
    't_reporting_period_carbon_emissions': 'Reporting Period Carbon Emissions ({0})',
    't_current_reporting_period_total_consumption': 'Current Reporting Period Total Consumption ({0})',
    't_current_reporting_period_gap_filled_data_percentage': 'Current Reporting Period Gap Filled Data (%)',
    't_previous_reporting_period_total_consumption': 'Previous Reporting Period Total Consumption ({0})',
    't_previous_reporting_period_gap_filled_data_percentage': 'Previous Reporting Period Gap Filled Data (%)',
    't_current_reporting_period_total_waste': 'Current Reporting Period Total Waste ({0})',
    't_current_reporting_period_recycled_waste': 'Current Reporting Period Recycled Waste ({0})',
    't_current_percentage_recycled': 'Current % Recycled',
    't_previous_reporting_period_total_waste': 'Previous Reporting Period Total Waste ({0})',
    't_hazardous_waste': 'Hazardous Waste ({0})',
    't_non_hazardous_waste': 'Non-hazardous Waste ({0})',
    't_total_waste_generated': 'Total Waste Generated ({0})',
    't_waste_to_energy_unit': 'Waste to energy ({0})',
    't_waste_generated': 'Waste Generated',
    't_destination': 'Destination',
    't_current_reporting_period_total_emissions': 'Current Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_total_emissions': 'Previous Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_recycled_waste': 'Previous Reporting Period Recycled Waste ({0})',
    't_emissions': 'Emissions',
    't_current_total_carbon_emissions': 'Current total Carbon Emissions ({0})',
    't_scope_1_emissions': 'Scope 1 emissions ({0})',
    't_scope_2_emissions': 'Scope 2 emissions ({0})',
    't_scope_3_emissions': 'Scope 3 emissions ({0})',
    't_current_period_consumption_with_gapFilled_data': 'Current period consumption ({0})',
    't_current_period_gapFilled_data': 'Current period Gap Filled Data (%)',
    't_previous_period_consumption_with_gapFilled_data': 'Previous period consumption ({0})',
    't_previous_period_gapFilled_data': 'Previous period Gap Filled Data (%)',
    't_previous_period_total_carbon_emissions': 'Previous period\'s total carbon emissions ({0})',
    't_current_consumption_with_gapFilled_data': 'Current period consumption ({0})',
    't_current_energy_consumption_with_gapFilled_data': 'Current energy consumption ({0})',
    't_previous_energy_consumption_kwh_with_gapFilled_data': 'Previous energy consumption ({0})',
    't_import_file_error_message': 'The import file name must not contain more than 50 characters',
    't_current_reporting_period_gap_filled_energy_data_percentage': 'Current Reporting Period Gap-Filled Energy Data (%)',
    't_previous_reporting_period_gap_filled_energy_data_percentage': 'Previous Reporting Period Gap-Filled Energy Data (%)',
    't_meter_name': 'Meter name',
    't_serial_number': 'Serial number',
    't_comment': 'Comment',
    't_active_from': 'Active from',
    't_active_to': 'Active to',
    't_is_this_a_submeter': 'Is this a submeter?',
    't_floor_area_served_by_meter': 'Floor area served by Meter ({0})',
    't_green_tariff': 'Green tariff',
    't_current_annual_consumption_includes_gap_filled_data': 'Current annual consumption ({0}) (includes gap-filled data)',
    't_previous_year_total_consumption_includes_gap_filled_data': 'Previous year\'s total consumption ({0}) (includes gap-filled data)',
    't_floor_area_served': 'Floor area served ({0})',
    't_previous_periods_total_consumption_includes_gap_filled_data': 'Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_waste_disposal_route_reference': 'Waste disposal route reference',
    't_contractor': 'Contractor',
    't_waste_type': 'Waste Type',
    't_previous_period_carbon_emissions': 'Previous period carbon emissions ({0})',
    't_previous_periods_total_consumption_include_gap_filled_data': 'Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_meter_information': 'Meter Information',
    't_no_export_data_available': 'The assets selected have no data available for this utility within the specified time frame.',
    't_actions_date': 'Based on {0}',
    't_export_performance_excel': 'Export performance - EXCEL',
    't_water_intensity_excel': 'Water Intensity ({0})',
    't_export_data_quality_excel': 'Export data quality - EXCEL',
    't_current_consumption_with_excluding_gapFilled_data': 'Current consumption ({0}) (excluding gap-filled data)',
    't_previous_consumption_with_excluding_gapFilled_data': 'Previous period consumption ({0}) (excluding gap-filled data)',
    't_current_energy_consumption_with_excluding_gapFilled_data': 'Current energy consumption ({0}) (excluding gap-filled data)',
    't_previous_energy_consumption_kwh_with_excluding_gapFilled_data': 'Previous energy consumption ({0}) (excluding gap-filled data)',
    't_manage_es_integration_link': 'Manage Energy Star integration',
    't_assets_info_with_no_agreed_actions': 'In the current NZC model, {0} out of {1} assets have no agreed energy-saving actions.',
    't_assets_info_with_agreed_actions': 'In current NZC model, all {0} assets have at least one energy-saving action defined.',
    't_data_below_target': 'Data below target',
    't_gap_filled_data_below_target': 'Gap-filled data below target',
    't_data_above_target': 'Data above target',
    't_gap_filled_data_above_target_updated': 'Gap-filled data above target',
    't_carbon_scope_info': '<p><b>Scope 1: </b>Carbon emissions from landlord gas and oil</p> <p><b>Scope 2: </b>Carbon emissions from landlord electricity, district heating and district cooling</p> <p><b>Scope 3: </b>Carbon emissions from tenant energy usage</p> ',
    't_data_quality_info': 'Reports can be compiled with any level of Data Quality using gap-filling, but this will affect the accuracy of your outputs. We recommend using the Data Quality page to increase the completeness of your data.',
    't_report_data_checklist_info': 'Select a reporting framework to highlight data readiness issues.',
    't_industry_standard_benchmark': 'Industry standard benchmark ({0})',
    't_variance_against_industry_standard_benchmark': 'Variance against Industry Standard Benchmark (%)',
    't_data_below_previous_period': 'Data below previous period',
    't_gap_filled_data_below_previous_period': 'Gap-filled data below previous period',
    't_data_above_previous_period': 'Data above previous period',
    't_gap_filled_data_above_previous_period': 'Gap-filled data above previous period',
    't_asset_nzc_action_based_target_pathway_info': 'Action-based pathways aggregate all of the energy-saving actions that have been defined in the current model and present them as a single pathway.',
    't_asset_nzc_custom_based_target_pathway_info': 'Custom target pathways allow you to specify your own targets over time for this asset in your model.',
    't_kwh_m2_yr': 'kWh/m²/yr',
    't_assets_with_scores': 'Assets with scores',
    't_gav_coverage': 'GAV coverage',
    't_date_completed': 'Date completed',
    't_total_emissions': 'Total Emissions',
    't_scope1_emissions': 'Scope 1 Emissions',
    't_scope2_emissions': 'Scope 2 Emissions',
    't_scope3_emissions': 'Scope 3 Emissions',
    't_missing_fund_data_weighted': 'Missing fund data, weighted by floor area (%)',
    't_commercial': 'Commercial',
    't_no_data_for_comparison': 'No data for comparison',
    't_landlord_tenant_split': 'Landlord/Tenant split',
    't_scope_breakdown': 'Scope breakdown',
    't_scope1_landlord': 'Scope 1 (Landlord)',
    't_scope2_landlord': 'Scope 2 (Landlord)',
    't_scope3_tenant': 'Scope 3 (Tenant)',
    't_scope1': 'Scope 1',
    't_scope2': 'Scope 2',
    't_scope3': 'Scope 3',
    't_net_change': 'Net change',
    't_required_asset_ref': 'Asset Reference *',
    't_impact_type': 'Impact (Type) *',
    't_gresb_efficiency_measure': 'GRESB Efficiency Measure',
    't_required_status': 'Status *',
    't_action_plan_title': 'Action Plan Title * (Max 50 Characters)',
    't_required_area_covered': 'Area Covered *',
    't_required_currency': 'Currency * \r\n(Required if applicable)',
    't_required_primary_utility_type': 'Primary Utility Type * \r\n(Required if applicable)',
    't_required_primary_utility_change': 'Primary Utility Change * \r\n(Required if applicable)',
    't_required_primary_utility_cost_change': 'Primary Utility Cost Change * \r\n(Required if applicable)',
    't_secondary_utility_type': 'Secondary Utility Type',
    't_secondary_utility_change': 'Secondary Utility Change',
    't_required_action_id': 'Action ID * \r\nDO NOT EDIT',
    't_active_inactive': 'Active / inactive',
    't_required_meter_pan': 'Meter name  / MPAN *',
    't_required_meter_id': 'Meter ID *',
    't_required_from_date': 'From date *',
    't_from_date': 'From date',
    't_required_to_date': 'To date *',
    't_required_consumption': 'Consumption (Energy in kWh, Water in m3) *',
    't_required_estimate_actual': 'Estimated/actual *',
    't_required_origin': 'Origin *',
    't_scheduled_date': 'Scheduled date',
    't_estimated_change': 'Estimated change',
    't_find_action': 'Find action',
    't_filters': 'Filters',
    't_btn_request_consumption': 'Request consumption',
    't_header_request_consumption': 'Request Consumption',
    't_additional_information': 'Additional Information',
    't_serial_number_consumption': 'Serial Number',
    't_utility_type_consumption': 'Utility Type',
    't_area_covered_consumption': 'Area Covered',
    't_meter_status': 'Meter Status',
    't_submeter': 'Submeter',
    't_all_categories': 'All categories',
    't_estimated_data': 'Estimated data',
    't_delete_record': 'Delete record',
    't_delete_records': 'Delete records',
    't_edit_record': 'Edit record',
    't_edit_records': 'Edit records',
    't_add_consumptions': 'Add consumption',
    't_asset_procurement_data_categories': '<p><b>Actual:</b> Consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_request_email_label': 'Recipients (separate emails with commas)',
    't_request_email_placeholder': 'Add email recipients',
    't_request_send_button': 'Send request email',
    't_email_sent_confirmation': 'Email sent',
    't_select_utility': 'Select Utility',
    't_utilities': 'Utilities',
    't_clear_all': 'Clear all',
    't_select_status': 'Select status',
    't_select_impact': 'Select impact',
    't_select_cost_type': 'Select cost type',
    't_select_scope': 'Select scope',
    't_select_procurement': 'Select procurement',
    't_search_meter_placeholder': 'Search meter name...',
    't_no_meter_data_available': 'This meter has no data available within the specified time frame',
    't_select_all': 'Select All',
    't_error_title': 'Error',
    't_delete_warn': 'Are you sure you want to delete this record?',
    't_delete_warn_s': 'Are you sure you want to delete these records?',
    't_delete_yes': 'Yes, delete',
    't_cancel_delete': 'No, cancel',
    't_no_export_data_available_for_single_asset': 'The asset selected have no data available for this utility within the specified time frame.',
    't_origin': 'Origin',
    't_submitted_by': 'Submitted by',
    't_gap_filled_scope': 'gap-filled',
    't_procured_data': 'procured data',
    't_meter_submitted_by': 'Submitted By',
    't_action_plan_improvement_sub_text': 'Recording action plans enables you to track improvement opportunities at your assets. You can manage a significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload action plans to SIERA, the data needs to be in accordance with our data template.',
    't_nzc_available_not_siera': 'Net Zero Carbon module not available.',
    't_estimated_actual_required': 'Estimated or Actual *',
    't_action_details': 'Action details',
    't_action_details_description': 'Key information associated with actions regarding how the Impact influences GRESB efficiency measures with Area coverage',
    't_action_information': 'Action information',
    't_action_title': 'Action title',
    't_action_impact_error_message': 'Please select a impact',
    't_action_title_error_message': 'Please select a title',
    't_action_status_error_message': 'Please select a status',
    't_current_consumption_with_gapFilled': 'Current consumption ({0})',
    't_previous_consumption_with_gapFilled_data': 'Previous period consumption ({0})',
    't_consumption_information': 'Consumption Information',
    't_add_consumption_title': 'Add Consumption',
    't_edit_record_title': 'Edit Record',
    't_edit_records_title': 'Edit Records',
    't_update_record': 'Update Record',
    't_update_records': 'Update Records',
    't_update_record_confirmation': 'Record updated',
    't_update_records_confirmation': 'Records updated',
    't_submit_consumption': 'Submit consumption',
    't_submit_confirmation': 'Consumption added',
    't_associated_costs_utility': 'Associated costs and Utility',
    't_associated_costs_utility_desc': 'The savings per utility type and its cost. Negative value shows greater savings reduction and a positive value shows an increase',
    't_cost_of_action': 'Cost of action',
    't_select_currency': 'Select currency',
    't_action_currency_error_message': 'Please select a currency',
    't_action_title_error_msg': 'Please add a title',
    't_nodata_for_timeperiod': 'There is no data available for this time period',
    't_back_to_list': 'Back to List',
    't_add_data': 'Add Data',
    't_edit_data': 'Edit Data',
    't_select_area_covered': 'Select area covered',
    't_action_area_covered_error_message': 'Please select the area covered',
    't_gresb_efficiency_measure_select': 'Select GRESB efficiency measure',
    't_gresb_efficiency_measure_error_msg': 'Please select a GRESB efficiency measure',
    't_cooling_tower_drip': 'Cooling tower Drip / Smart irrigation',
    't_onsite_waste_water_treatment_reuse_of_storm_water': 'On-site waste water treatment / Reuse of storm water / Grey water',
    't_building_specific_communication': 'Building specific communication (i.e. posters, emails or newsletters)',
    't_feedback_sessions_individual_tenants': 'Feedback sessions with individual tenants - e.g. discussing sustainability requirements',
    't_social_media_online_platform': 'Social media / Online platform',
    't_tenant_meetings_which_includes': 'Tenant meetings which includes sustainability',
    't_tenant_sustainability_events': 'Tenant sustainability events',
    't_tenant_sustainability_guide': 'Tenant sustainability guide',
    't_tenant_sustainability_training': 'Tenant sustainability training',
    't_Tenants_feedback_energy_water_waste': 'Tenants receive feedback on energy, water or waste performance',
    't_gap_filled_split': 'Gap-filled',
    't_action_scheduled_completion_date': 'Scheduled completion date',
    't_action_completion_date': 'Completion date',
    't_select_primary_utility': 'Select primary utility',
    't_select_secondary_utility': 'Select secondary utility',
    't_primary_utility': 'Primary utility',
    't_secondary_utility': 'Secondary utility',
    't_primary_utility_error_message': 'Please select a primary utility',
    't_primary_utility_cost_error_msg': 'Please enter a change',
    't_choose_breakdown': 'Choose breakdown',
    't_modified_date': 'Modified date',
    't_gap_filling': 'Gap-filling',
    't_sold_badge_label': 'Sold in',
    't_view_detailed_dq_break_down': 'View detailed Data Quality breakdown',
    't_gresb_not_mandatory': 'GRESB efficiency measure selection is not mandatory but recommended',
    't_required_asset_name': 'Asset Name *',
    't_purchased': 'Purchased',
    't_nzc_sold': 'Sold',
    't_edit_asset': 'Edit asset',
    't_back_action_plan': 'Back to Action Plan',
    't_key_metrics': 'Key Metrics',
    't_payback_period': 'Payback period',
    't_matched_assets_count': '{0} assets selected, please match the remaining assets',
    't_search_by_asset': 'Search by asset name',
    't_select_available_match': 'Select from {0} available matches',
    't_fund_sfdr_pai_report': 'SFDR PAI Report',
    't_y_o_y_trend': 'Year-on-Year Trend',
    't_adverse_sustainability_impact': 'Adverse Sustainability Impact',
    't_tonnes_co2e': 'tonnes CO2e',
    't_ghg_scope1': 'Scope 1 GHG emissions generated by real estate assets',
    't_ghg_scope2': 'Scope 2 GHG emissions generated by real estate assets',
    't_ghg_scope3': 'Scope 3 GHG emissions generated by real estate assets',
    't_ghg_scope_total': 'Total GHG emissions generated by real estate assets',
    't_including_estimates': 'Including estimates',
    't_actual_only': 'Actual Only',
    't_percentage': 'Percentage',
    't_vertical': 'Vertical',
    't_horizontal': 'Horizontal',
    't_fossil_fuels': 'Fossil Fuels',
    't_adverse_impact_ghg_emissions_by_scope': 'GHG emissions by scope',
    't_gia_tooltip_content': 'This is the total internal floor area associated with the asset and should equal the NLA and CPA.',
    't_nla_tooltip_content': 'This is the floor area associated with the lettable space only ( e.g. office or retail space) and excludes communal areas.',
    't_cpa_tooltip_content': 'This is the area associated with communal spaces such as reception areas, lift lobbies, stairwells and shared toilets.',
    't_ext_tooltip_content': 'This is the area associated with external areas such as car parks.',
    't_effect_on_utilities': 'Effect on utilities',
    't_single_year': 'year',
    't_multiple_years': 'years',
    't_gia_nla_required_message': 'Please ensure at least one field (GIA or NLA) is filled in',
    't_generic_number_message': '{field} must be a number',
    't_generic_positivenumber_message': '{field} must be a positive number',
    't_horizontal_artificial_less_than_total_message': 'Horizontal artificial cannot be greater than the total horizontal area',
    't_vertical_artificial_less_than_total_message': 'Vertical artificial cannot be greater than the total vertical area',
    't_planning_permission_date_before_purchase': 'Must be before the year the asset was built (see Asset Details)',
    't_gia_nla_cpa_ext_length_validation_message': 'Amount entered is low. Please verify before continuing',
    't_gia_nla_cpa_adding error': 'Please ensure the values for the NLA and CPA equal the GIA',
    't_date_required': 'Please enter a date',
    't_future_year_error':'The year built can not be in the future',
    't_past_year_error' :'Year Built should be greater than 1800',
    't_invalid_year_error':'Invalid year format. Please enter a valid year',
    't_future_date_error': 'Date cannot be in the future',
    't_sale_date_error': 'Sale date must be after the purchase date',
    't_sale_date_before_purchase_date_error': 'Please enter the purchase date',
    't_post_note': 'Post a note',
    't_clear_note': 'Clear note',
    't_higher_than_target': 'higher than target',
    't_lower_than_target': 'lower than target',
    't_higher_than_previous_period': 'higher than previous period',
    't_lower_than_previous_period': 'lower than previous period',
    't_date_created': 'Date created',
    't_created_by': 'Created by',
    't_gresb_sector_tooltip': 'Select the sub type that best represents your asset , as per the  GRESB standard.',
    't_energy_star_sector_tooltip': 'Select the relevant sector from Energy Star categories that best describes your asset\'s industry for energy performance tracking and benchmarking.',
    't_operation_control_landlord_controlled_tooltip': '{dynamic}: The Landlord has complete or partial ability to change operating policies, environmental policies and the purchase of utilities.',
    't_operation_control_tenant_controlled_tooltip': '{dynamic}: Only the Tenant(s) have control over operating policies, environmental policies and the purchase of utilities.',
    't_please_select_option_from_dropdown_from_dropdown': 'Please select an option from the dropdown',
    't_sync_success_message': 'Sync complete',
    't_notes_in_actions_not_saved': 'Do you want to save the changes to the action before navigating away?',
    't_select_the_country_of_asset': 'Select the country of the asset',
    't_select_the_region_of_asset': 'Select the region of the asset',
    't_enter_asset_name':'Please Enter Asset Name',
    't_validation_asset_name':'Asset name already exists. Choose a different name',
    't_validation_asset_reference':'Asset reference already exists. Choose a different reference',
    't_enter_asset_reference':'Please Enter Asset Reference',
    't_select_assetdetails_fund':'Select a fund',
    't_asset_ownership_invalid_input':'Invalid input. Please enter a numeric percentage value',
    't_asset_ownership_required':' Please enter a Fund Ownership %',
    't_asset_ownership_min_value':'Range should be between 1-100',
    't_asset_ownership_max_value':'Range should be between 1-100',
    't_asset_name_exists_message':'Asset Name already exist, choose some other name',
    't_documents': 'Documents',
    't_pai_selection': 'PAI selection',
    't_real_estate_mandatory': 'Mandatory for Real Estate',
    't_select_at_least': 'Select at least one from below',
    't_operational_control_asset': 'Select the Operational Control for the asset',
    't_select_at_least_one_option': 'Please select at least one option from the dropdown',
    't_warning_gas_district_heating': 'Gas and district heating selected. Is this correct?',
    't_warning_gas_district_cooling': 'Gas and district cooling selected. Is this correct?',
    't_warning_gas_district_heating_and_district_cooling': 'Gas and district heating/district cooling selected. Is this correct?',
    't_enter_date_of_evaluation': 'Enter the date of this last evaluation',
    't_keyfacts': 'Key Facts',
    't_performance_overview': 'Performance overview',
    't_variance_against_target': 'Variance against target',
    't_variance_against_previous_period': 'Variance against previous period',
    't_below': 'below',
    't_above': 'above',
    't_gap_filled_data_not_applicable': 'gap-filled data not applicable',
    't_documents_n_certificates': 'Documents & Certificates',
    't_consumption_evidence': 'Consumption Evidence',
    't_filter_applied': '{0} filter applied.',
    't_filters_applied': '{0} filters applied.',
    't_download_documents': 'Download documents',
    't_pai_report': 'PAI Report',
    't_fossil_fuel_impact_report': 'Fossil Fuel Exposure Impact Report',
    't_energy_efficiency_impact_report': 'Energy Efficiency Impact Report',
    't_ghg_impact_report': 'GHG Emissions Impact Report',
    't_energy_consumption_impact_report': 'Energy Consumption Impact Report',
    't_waste_impact_report': 'Waste Management Impact Report',
    't_resource_consumption_impact_report': 'Resource Consumption Impact Report',
    't_biodiversity_impact_report': 'Biodiversity Impact Report',
    't_quarterly_summary': 'Quarterly Summary',
    't_exposed_value': 'Exposed Value',
    't_total_applicable_value': 'Total Applicable Value',
    't_total_excluded_value': 'Total Excluded Value',
    't_share_applicable_value_exposed': 'Share of applicable value exposed',
    't_share_total_value_excluded': 'Share of total value excluded',
    't_principle_metrics': 'Principle Metrics',
    't_average_share_exposed_value': 'Average share of exposed value',
    't_average_share_total_value_excluded': 'Average share of total value excluded',
    't_ped_below_nzeb': 'PED below NZEB?',
    't_total_portfolio_value': 'Total Portfolio Value',
    't_construction_year': 'Construction Year',
    't_total_scope1_emissions': 'Total Scope 1 Emissions',
    't_total_scope2_emissions': 'Total Scope 2 Emissions',
    't_total_scope3_emissions': 'Total Scope 3 Emissions',
    't_total_ghg_emissions': 'Total GHG Emissions',
    't_actual_data_only': 'Actual data only',
    't_including_estimations': 'Including estimations',
    't_exposed_value_share': 'Share of exposed value',
    't_inefficient_re': 'Inefficient RE',
    't_overview': 'Overview',
    't_ghg': 'GHG',
    't_ghg_emissions': 'GHG Emissions',
    't_total_contributing_area': 'Total contributing area',
    't_total_raw_material_usage': 'Total Raw Material Usage',
    't_sustainable_raw_material_usage': 'Sustainable Raw Material Usage',
    't_sustainable_raw_material_usage_share': 'Share of Sustainable Raw Material Usage',
    't_horizontal_artificialization': 'Horizontal Artificialisation',
    't_vertical_artificialization': 'Vertical Artificialisation',
    't_top_down_pathways': 'Top-Down pathways',
    't_upload_top_down_pathways': 'Upload top-down pathways',
    't_coverage_by_floorArea': 'Coverage by floor area',
    't_filename': 'File Name',
    't_document_type': 'Document Type',
    't_implementation_date': 'Implementation Date',
    't_date_of_upload': 'Date of Upload',
    't_uploaded_by': 'Uploaded by',
    't_fundname': 'Fund Name',
    't_document_size': 'Document Size',
    't_export_documents': 'Export documents',
    't_validation_errors':'Record has validation errors',
    't_validation_warning':'Record has warnings',
    't_validation_consumption_blank':'Please enter consumption for this date range.',
    't_validation_consumption_specific':'Please specify whether this consumption is estimated or actual.',
    't_validation_source':'Please specify the origin of the consumption figure, for example invoice or meter reading.',
    't_validation_from_date_blank':'Please enter from date.',
    't_validation_to_date_blank':'Please enter to date.',
    't_validation_comment':'This is now a required field, because you calculated an estimate for this consumption figure. Please explain the methodology behind your calculation.',
    't_validation_negative_not_allowed':'SIERA cannot accept negative values. Please get in touch with our support team or adjust your consumption by pro-rating. {0}.',
    't_warning_consumption_inactive':'You are submitting consumption for a meter that is tagged as inactive during this time period. Please check your dates are correct, and check the meter status is up to date.',
    't_warning_consumption_same_period':'This consumption figure is +-10% for the same period in the previous year. Please check you have entered it correctly before proceeding, including decimal places and unit of measurement.',
    't_warning_consumption_same_diff_period':'The exact consumption figure has been uploaded to a different meter before. Please check it is correct before proceeding.',
    't_validation_from_date_before_today':'As you are submitting actual (not estimated) consumption, please select a date before today.',
    't_validation_from_date_lesser':'From date should be less than or equal to To date.',
    't_validation_date_overlap':'We already have consumption data for {0}. Please adjust your data to a new date range to avoid overlaps. {1}.',
    't_upload_nzc_top_down_pathways': 'Upload NZC Top-Down Pathway',
    't_upload_nzc_top_down_pathways_subtext': 'You can import up to 7 NZC Top-Down pathways simultaneously. In order to upload the pathway data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload NZC Top-Down Pathways into Siera.',
    't_upload_nzc_top_down_pathways_point_one': 'Generate and populate your template',
    't_upload_nzc_top_down_pathways_point_one_subtext': 'Populate the template with your list of Pathways. The template has been partially populated to help you get the data in the right place.',
    't_upload_nzc_top_down_pathways_point_two': 'Upload NZC Top-Down pathways data',
    't_upload_nzc_top_down_pathways_point_two_subtext': 'When you upload your completed template, you will be guided through an error handling process.',
    't_actions_breakdown': 'Actions breakdown',
    't_filenames': 'File Name(s)',
    't_metername': 'Meter Name',
    't_select_the_status_of_asset':'Please select a status for this asset.',
    't_to_tc': 'To',
    't_delete_document': 'Delete document',
    't_confirm_delete_document': 'Are you sure you want to delete this document?',
    't_confirm_delete_documents': 'Are you sure you want to delete these documents?',
    't_previous_period_recycled': 'previous period (recycled)',
    't_select_a_status': 'Select a status',
    't_remove_item': 'Remove item',
    't_add_new_record': 'Add new record',
    't_add_old_record': 'Add old record',
    't_select_date_error': 'Please select a date',
    't_date_set_automatically': 'This date is set automatically by the above item\'s Start date. This is to make sure there\'s no gaps or overlaps between items on the timeline.',
    't_present': 'Present',
    't_top_down_carbon_intensity' : 'Top-Down Carbon intensity',
    't_top_down_energy_intensity' : 'Top-Down Energy intensity',
    't_top_down_pathways_template_filename' : 'Upload_NZC_TopDown_Pathways_Template',
    't_top_down_pathways_carbon_template_title' : 'Uploading NZC Top Down Pathways - Carbon Intensity',
    't_top_down_pathways_energy_template_title' : 'Uploading NZC Top Down Pathways - Energy Intensity',
    't_how_to_use_this_template' : 'How to use this template',
    't_pathway_name':'Pathway Name',
    't_pathway':'Pathway',
    't_top_down_template_instruction_1' : 'This excel sheet is used to upload Top Down Pathways.',
    't_top_down_template_instruction_2' : 'This sheet has rows where you enter the Pathway names - these are editable with a max character limit of 40.',
    't_top_down_template_instruction_3' : 'You can only upload upto a maximum of 7 pathways (rows).',
    't_top_down_template_instruction_4' : 'The columns indicate the Years, these are pre-selected from 2019-2050.',
    't_top_down_template_instruction_5' : 'You can choose to enter in any cells under the year column (can also leave them blank).',
    't_top_down_template_instruction_6' : 'You must enter numerical values in these cells.',
    't_top_down_template_instruction_7' : 'Please make sure you know the units you are using from Siera.',
    't_sustainable_weight_greater_than_total_weight': 'Sustainable materials weight cannot be greater than the total weight',
    't_start_date_before_end_date': 'Start date must be before end date',
    't_total_missing_data': 'total missing data',
    't_filter_documents': 'Filter documents',
    't_filter_consumption_evidence': 'Filter consumption evidence',
    't_valid_within': 'Valid within',
    't_evidence_date_range': 'Evidence date range',
    't_pick_date_range': 'Pick a date range',
    't_pick_evidence_date_range': 'Pick evidence date range',
    't_doc_type': 'Document type',
    't_select_doc_type': 'Select document type',
    't_select_doc_fund': 'Select fund',
    't_select_asset': 'Select asset',
    't_select_doc_country': 'Select country',
    't_select_managing_agent': 'Select managing agent',
    't_select_user': 'Select user',
    't_search_fund': 'Search by fund name',
    't_search_asset': 'Search by asset name or asset ref',
    't_search_name': 'Search by name',
    't_search_document': 'Search by document name',
    't_search_country': 'Search by country name',
    't_select_meter': 'Select meter',
    't_search_meter': 'Search meter',
    't_search_sector': 'Search sector',
    't_assurance_doc': 'Assurance document',
    't_audit_report': 'Audit/Recommendations report',
    't_energy_rating_certificate': 'Energy rating certificate',
    't_fund_report': 'Fund reports',
    't_green_building_certificate': 'Green building certificate',
    't_sustainability_action_plan': 'Sustainability action plan',
    't_exposed': 'Exposed',
    't_not_exposed': 'Not exposed',
    't_renewable_energy_certificate':'Renewable energy certificate',
    't_expiry_date':'Expiry date',
    't_select_expiry_date':'Select expiry date',
    't_report_date':'Report date *',
    't_select_report_date':'Select a valid report date',
    't_record_type_document':'Which record type does this document belong to? *',
    't_select_record_type':'Select record type',
    't_select_document_type':'Select document type',
    't_drag_drop':'Drag and drop or',
    't_document_select_file':'Select file',
    't_document_export':'Document Export',
    't_add_document':'Add document',
    't_search_fund_ref':'Search by fund name',
    't_delete_top_down_pathway': 'Delete top-down pathway',
    't_delete_topdownpathway_confirm_text': 'Are you sure you want to delete this top-down pathway?',
    't_active': 'Active',
    't_inactive': 'Inactive',
    't_saved':'Saved',
    't_document_upload':'Document upload *',
    't_asset_reference_address': 'Asset Reference & Address',
    't_clear_filters':'Clear filters',
    't_variance_previous_period_or_target':'Variance from previous period or target',
    't_reports_assetplanningpermissiondate_not_found_msg': 'Planning Permission Date cannot be empty.',
    't_reports_gav_not_found_msg': 'GAV must be stated for the entirety of {reportingPeriod}.',
    't_reports_fossilfuelexposure_not_found_msg': 'Fossil Fuel Exposure must be stated for the entirety of {reportingPeriod}.',
    't_reports_wasteproduction_not_found_msg': 'Waste Contract status must be stated for the entirety of {reportingPeriod}.',
    't_reports_ped_not_found_msg': '{fields} cannot be empty if planning permission was received after 31/12/2020.',
    't_reports_biodiversity_not_found_msg': '{areas} cannot be empty.',
    't_reports_resource_consumption_not_found_msg': '{areas}cannot be empty if current status is Major Renovation or New Construction.',
    't_sustainableweight_not_found_msg': '{areas} cannot be empty.',
    't_totalweight_not_found_msg': '{areas} cannot be empty.',
    't_startdate_not_found_msg': '{areas} cannot be empty.',
    't_enddate_not_found_msg': '{areas} cannot be empty.',
    't_reports_sustainableweight_not_found': 'Sustainable Weight',
    't_reports_totalweight_not_found': 'Total Weight',
    't_reports_startdate_not_found': 'Start Date',
    't_reports_enddate_not_found': 'End Date',
    't_top_down_pathway_success_message_one' : '{0} NZC Top-Down pathways have been uploaded on your model.',
    't_top_down_pathway_success_message_one_single_pathway' : '{0} NZC Top-Down pathway has been uploaded on your model.',
    't_top_down_pathway_success_message_two' : 'Your data will be available to view on your NZC model.',
    't_return_to_net_zero_carbon' : 'Return to Net Zero Carbon',
    't_save_document':'Save document',
    't_save_documents':'Save documents',
    't_edit_document':'Edit document',
    't_add_another_document':'Add another document',
    't_variance_explanation_title': 'Variance explanation',
    't_variance_explanation': 'Variance for a utility compared to the previous period, or to the target if one is set',
    't_add_new_document':'New document',
    't_update_document':'Update document',
    't_update_documents':'Update documents',
    't_document_updated':'Updated',
    't_document_report_date':'Report date',
    't_document_expiry_date':'Expiry date',
    't_target_variance': 'Target variance',
    't_period_variance': 'Period variance',
    't_landlord_data':'Landlord Data',
    't_tenant_procurement':'Tenant Procurement',
    't_planning_permission_before_year_built':'Planning Permission Date must be before the Year built.',
    't_impact_info': 'What does this action affect in overall regarding sustainablity',
    't_cost_type_info': 'Can the cost associated with actions be something that can be recovered',
    't_scope_info': 'Outlining which controlled areas in terms of utilities are affected independent if they are Landlord/Tenant controlled',
    't_gresb_info': 'Actions undertaken to reduce consumption and improve efficient use of utilities as a sustainable resource',
    't_payback_period_info': 'Time required to recoup the cost of action via the savings generated through its investment',
    't_effect_utilities': 'The savings per utility type and its cost. Negative value shows greater savings/reduction and Positive shows an increase',
    't_utility_consumption_year': 'Utility consumption per year',
    't_utility_cost_year': 'Utility cost per year',
    't_utility_consumption_year_info': '<info_title>Utility consumption after implementing action.</info_title>{0} {1}',
    't_utility_cost_year_info': '<info_title>Costs per year of running the utility after implementing action.</info_title>{0} {1}',
    't_tenant_controlled': 'Tenant controlled',
    't_landlord_controlled': 'Landlord controlled',
    't_cannot_be_empty':'This field cannot be empty',
    't_add_asset_success': 'Asset has been created',
    't_add_asset_summary': 'Everyone within the fund will have access. To provide non-fund-level users access, go to user permissions.',
    't_edit_asset_title': 'Asset has been updated',
    't_edit_asset_summary': 'Updates across all modules will be reflected shortly.',
    't_select_framework': 'Select a framework',
    't_utility_per_year': 'Utility per year',
    't_cost_per_year': 'Cost per year',
    't_utility_per_year_info_content_one': '1000 {0} = 1000 {1} increase over a year',
    't_utility_per_year_info_content_two': '-1000 {0} = 1000 {1} decrease over a year',
    't_cost_per_year_info_content_one': '{0}100/yr = {0}100 increase in cost per year',
    't_cost_per_year_info_content_two': '-{0}100/yr = {0}100 decrease in cost per year',
    't_year_dynamic': 'Year {year}',
    't_ped_tooltip_content': 'An asset’s Primary Energy Demand (PED) models the amount of energy which must be extracted from primary sources to supply the asset’s typical energy usage, and can often be found on an EPC.',
    't_nzeb_tooltip_content': 'The NZEB Threshold is the energy performance target an asset must meet to qualify as a Nearly Zero-Energy Building, calculated according to the appropriate national methodology. Non-EU nations will not have an applicable NZEB threshold.',
    't_sustainable_tonnes_tooltip_content': 'Sustainably sourced refers to materials which are recovered, recycled or bio-sourced.',
    't_horizontal_artificial_tooltip_content': 'The amount of plan or “bird’s eye” surface area which is non-vegetated.',
    't_total_horizontal_tooltip_content': 'The total plan or “bird’s eye” surface area of the asset.',
    't_vertical_artificial_tooltip_content': 'The amount of external, vertical surface area which is non-vegetated.',
    't_total_vertical_tooltip_content': 'The total external, vertical surface area of the asset.',
    't_click_to_read': 'Click here to read more',
    't_reporting_years': 'Reporting Years',
    't_data_readiness': 'Data Readiness',
    't_waste_contract_status': 'Waste Contract Status',
    't_evaluation_date': 'Evaluation Date',
    't_add_new_status': 'Add new status',
    't_add_historic_status': 'Add historic status',
    't_add_new_exposure': 'Add new exposure',
    't_add_historic_exposure': 'Add historic exposure',
    't_siera_version': 'SIERA version',
    't_renewables': 'Renewables',
    't_on_site_generation': 'On-site generation',
    't_gia_percentage': '{0}% of your GIA {1}',
    't_assets_count': '{0} assets',
    't_self_consumption': '{0}% Self consumption',
    't_export_to_grid': '{0}% Exported to grid',
    't_contribution_electricity_consumption': '{0}% Contribution to electricity consumption',
    't_on_site_generated': '{0}% On site generated',
    't_off_site_purchased': '{0}% Off-site purchased',
    't_non_renewables': '{0}% Non-renewables',
    't_renewables_floor_area': 'Renewables floor area',
    't_renewables_floor_area_info': 'This percentage is calculated via the number of asset count with on site generation weighted by the floor area',
    't_detailed_renewables_soon': 'Detailed performance view for Renewables coming soon.',
    't_record_type_asset_document':'Which asset does this document belong to? *',
    't_valid_from_document':'Valid from date *',
    't_expiry_date_mandatory':'Expiry date *',
    't_end_date_after_start_date': 'End date must be after start date',
    't_action_deleted': 'Action successfully deleted',
    't_action_deleted_content': '‘{0}’ action has been deleted by {1}',
    't_select_agent': 'Select Agent',
    't_supplier_estimate': 'Supplier estimate',
    't_calculated_estimate': 'Calculated estimate',
    't_dq_total_asset_floor_area': 'Total Asset Floor Area',
    't_floor_area_unaccounted_for': 'Floor area unaccounted for',
    't_action_name_exists': 'Action name must be unique for the selected asset',
    't_managing_agent_upper_case': 'Managing Agent',
    't_data_coverage' : 'Data coverage',
    't_data_completeness': 'Data completeness',
    't_fund_data_coverage': '<p><b>Floor area coverage:</b> Where we have information about meters in a given part of the building for a given utility.</p> <p><b>Floor area unaccounted for: </b> Where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p>',
    't_fund_data_completeness': '<p><b>Actual:</b> Consumption data entered for a meter.</p> <p><b>Supplier estimate:</b> Meter data derived from supplier estimates (e.g. from invoices). These should be treated as actual data for reporting purposes, but they are still less accurate for precise performance monitoring.</p> <p><b>Calculated estimate:</b> Meter data derived from calculated estimates (e.g. calculated by an EVORA consultant using an accepted methodology).</p> <p><b>Missing:</b> Where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p>',
    't_add_new_evaluation': 'Add new Evaluation',
    't_add_new_occupancy': 'Add new Occupancy',
    't_documents_space_exceed':'You have exceeded your organisation\'s maximum storage capacity. To upload this document, please {0} to increase your storage limit.',
    't_data_category' : 'Data Category',
    't_supplier': 'Supplier',
    't_area_served': 'Floor Area Served',
    't_add_consumption': 'Add consumption',
    't_all_data_categories': 'All data categories',
    't_agreed_actions_count_nzc':'{0} Agreed actions',
    't_applicable_actions_count_nzc':'{0} Applicable actions',
    't_stranding_year_year': '{0} (CRREM Misalignment year)',
    't_not_stranding': 'Not CRREM Misaligned',
    't_actions_pathway_recommended': 'Actions pathway (recommended)',
    't_actions_pathway_optional': 'Actions pathway (optional)',
    't_agreed_actions_pathway': 'Agreed actions pathway',
    't_applicable_actions_pathway': 'Applicable actions pathway',
    't_bau_pathway': 'Business as usual pathway',
    't_fund_view': 'Fund view',
    't_assets_list': 'Assets list',
    't_chart_specification': 'Chart specification',
    't_chart_preconfigured': 'This chart has been preconfigured to display:',
    't_grid_decarbonisation_toast': '- Grid decarbonisation',
    't_sbt_toast': '- Science based target (1.5C)',
    't_bau_toast': '- Business as Usual',
    't_agreed_actions_toast': '- Agreed Action based pathways',
    't_reporting_year_value': 'Reporting year: {0}',
    't_cost_intensity_value': '{0} GBP/m²/yr',
    't_energy_intensity_value': '{0} kWh/m²/yr',
    't_carbon_intensity_value': '{0} kgCO₂e/m²/yr',
    't_co2_emissions_value': '{0} tCO₂e/yr',
    't_data_coverage_percentage_value' : '{0}% Data coverage',
    't_origin_meter_reading': 'Meter reading',
    't_origin_invoice': 'Invoice',
    't_origin_amr': 'AMR',
    't_actual_data': 'Actual data',
    'jv_between_funds': 'Joint venture between funds:',
    't_meter_inactive_sold': 'Meter was inactive or asset was not owned during this month',
    't_coverage': 'Coverage',
    't_completeness': 'Completeness',
    't_total_asset_floor_gia': 'Total asset floor area',
    't_expiry_date_must_be_after_report_date': 'Expiry date must be after report date',
    't_unique_file_name': 'A file with this name already exists',
    't_special_character': 'File name can\'t contain any of the following [ ] # * = / : \\ \' " | , < > & ?',
    't_special_character_comment': 'Comment can\'t contain special characters',
    't_custom': 'Custom'
  }
}